<template>
    <div class="orderorder">
        <!-- 单据功能按钮 -->
        <div
            style="display: flex; align-items: center; justify-content: space-between; padding: 0 10px; box-sizing: border-box">
            <div style="display: flex; align-items: center">
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg)"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('1')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !last ? 'gray' : ''"
                    style="width: 30px; transform: rotate(180deg); margin: 0 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('2')"
                />
                <img
                    src="../../../../screenshots/next1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px; margin-right: 15px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('3')"
                />
                <img
                    src="../../../../screenshots/last1.png"
                    :class="nullBtn || !first ? 'gray' : ''"
                    style="width: 30px"
                    alt=""
                    @click="isAdd == true || !isedit == true ? '' : changePage('4')"
                />
            </div>
            <div style="float: right">
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-plus"
                    :disabled="isAdd || !isedit"
                    @click="add"
                    v-if="perData.allow_add == 1"
                >{{ $t('common.add') }}
                </el-button
                >
                <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-edit"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="handelEdit"
                    v-if="perData.allow_edit == 1"
                >{{ $t('common.edit') }}
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-delete"
                    :disabled="isAdd || !isedit || isCheck || nullBtn"
                    @click="delOrder"
                    v-if="perData.allow_dele == 1"
                >{{ $t('common.delete') }}
                </el-button
                >
                <el-button type="info" size="mini" @click="goHistory" :disabled="!isedit">{{ $t('common.historyBill')
                    }}
                </el-button>
                <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-printer"
                    v-if="perData.allow_print == 1"
                    :disabled="!isedit || nullBtn"
                    @click="printOut"
                >{{ $t('common.print') }}
                </el-button
                >
                <el-button type="primary" size="mini" @click="exportFile" :disabled="!isedit">{{ $t('common.export')
                    }}
                </el-button>
                <el-button type="primary" :disabled="isAdd || !isedit || nullBtn" plain @click="Check(form.check)">{{
                        form.check == 1 ? $t('common.cancelAudit') : $t('common.audit')
                    }}
                </el-button>
            </div>
        </div>
        <!-- 单据操作信息 -->
        <div class="top_col">
            <el-row :gutter="20">
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.creator') }}：<span>{{ form.build_name }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifier') }}：<span>{{ form.modify_name }}</span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="grid-content bg-purple">
                        {{ $t('common.createTime') }}：<span>{{ form.build_date }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.modifyTime') }}：<span>{{ form.modify_date }}</span>
                    </div>
                </el-col>
                <el-col :span="3">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditor') }}：<span>{{ form.check_name }}</span>
                    </div>
                </el-col>
                <el-col :span="2">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditStatus') }}：<span
                        :style="{ color: form.check == 1 ? '' : 'red' }">{{ form.check == 1 ? $t('common.audited') : $t('common.notAudited')
                        }}</span>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div class="grid-content bg-purple">
                        {{ $t('common.auditTime') }}<span>{{ form.check_date }}</span>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 主表表单 -->
        <div class="top_cols" style="padding-bottom: 0">
            <el-form :model="form">
                <el-row :gutter="20">
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billNo') + '：'" label-width="180">
                            <el-input v-model="form.bill_no" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.billDate') + '：'" label-width="180" required>
                            <el-date-picker
                                type="datetime"
                                :disabled="isedit"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期"
                                v-model="form.bill_date"
                                style="width: 100%"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.billType') + '：'" required>
                                <mySelect
                                    v-model="form.billtype_no"
                                    :options="allArr.billtype"
                                    values="billtype_no"
                                    labels="billtype_name"
                                    keys="billtype_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.customer') + '：'" label-width="180" required>
                            <mySelectOptimized
                                v-model="form.cust_no"
                                :options="allArr.cust"
                                values="cust_no"
                                labels="cust_name"
                                keys="cust_no"
                                :disable="isedit"
                                @input="selectCust"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.counter') + '：'" label-width="180" required>
                            <mySelect
                                v-model="form.counter_no"
                                :options="allArr.counter"
                                values="counter_no"
                                labels="counter_name"
                                keys="counter_no"
                                :disable="isedit"
                                @input="selectCounter"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.salesman') + '：'" label-width="180">
                            <mySelect
                                v-model="form.salesman_no"
                                :options="allArr.salesman"
                                values="salesman_no"
                                labels="salesman_name"
                                keys="salesman_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="4">
                        <div class="input_col">
                            <el-form-item :label="$t('common.currency') + '：'">
                                <mySelect
                                    v-model="form.currency_no"
                                    :options="allArr.currency"
                                    values="currency_no"
                                    labels="currency_name"
                                    keys="currency_no"
                                    :disable="isedit"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <el-form-item :label="$t('common.handler') + '：'" label-width="180">
                            <mySelect
                                v-model="form.staff_no"
                                :options="allArr.staff"
                                values="staff_no"
                                labels="staff_name"
                                keys="staff_no"
                                :disable="isedit"
                            />
                        </el-form-item>
                    </el-col>

                    <el-col :span="4" v-if="systemSet.isstores == 1">
                        <div class="input_col">
                            <el-form-item :label="$t('common.store') + '：'">
                                <mySelect
                                    v-model="form.store_no"
                                    :options="allArr.store"
                                    values="store_no"
                                    labels="store_name"
                                    keys="store_no"
                                    :disable="isedit"
                                    :clearables="false"
                                    @input="selectStore"
                                />
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="systemSet.isstores == 1 ? 12 : 16">
                        <el-form-item label-width="200" :label="$t('common.remark') + '：'">
                            <el-input type="textarea" :rows="1" v-model="form.remark" :disabled="isedit"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <!-- 明细表格与物料明细表格 -->
        <div class="dtl_bom_warpper">
            <!-- 明细表格 -->
            <div class="table1 dtl_main" :class="{ dtl_main_full: systemSet.isBarcodesAssembly != 1 }" @mouseleave="dtlleave">
                <div class="title">
                    <div style="display: flex">
                        <p style="margin-right: 20px">{{ $t('common.productDetail') }}</p>
                        <!-- <vxe-input
                            :disabled="isedit"
                            placeholder="请输入条码号"
                            @keydown.native.enter="insertTableBcode('input', $event)"
                            v-model="insertKeyword"
                            clearable
                            style="width: 200px; border-radius: 0px !important"
                        >
                        </vxe-input> -->
                        <input
                            :disabled="isedit"
                            placeholder="请输入条码号"
                            @keydown.enter="insertTableBcode('input', $event)"
                            v-model.lazy="insertKeyword"
                            clearable
                            style="width: 200px; border-radius: 0px !important; font-size: 14px"
                            class="el-textarea__inner"
                        />
                        <el-button
                            style="margin-left: 0px; border-radius: 0px !important"
                            type="primary"
                            :disabled="isedit"
                            @click="dialogTrueFalse"
                        >批量扫码
                        </el-button
                        >

                        <vxe-input
                            :disabled="isedit"
                            placeholder="请输入采购单号"
                            @keydown.native.enter="insertCBillno($event)"
                            v-model="insertBillno"
                            clearable
                            style="width: 200px; margin-left: 10px"
                        >
                        </vxe-input>

                        <el-button style="margin-left: 10px" type="primary" :disabled="isedit" @click="showImpotOpen">
                            RFID扫码
                        </el-button>
                    </div>

                    <div>
                        <el-button type="" :disabled="isedit" @click="showUpFieldDialog">批量修改单价</el-button>
                        <el-button type="" :disabled="isedit" @click="showImpotDialog = true">导入</el-button>
                        <el-button type="" :disabled="isedit" @click="closingPrice(1)">
                            {{ $t('common.allPriceSettlement') }}
                        </el-button>
                        <el-button type="" :disabled="isedit" @click="closingPrice(2)">
                            {{ $t('common.allMaterialSettlement') }}
                        </el-button>
                        <el-button type="" :disabled="isedit" @click="closingPrice(3)">
                            {{ $t('common.sequentialPriceSettlement') }}
                        </el-button>
                        <el-button type="" :disabled="isedit" @click="closingPrice(4)">
                            {{ $t('common.sequentialMaterialSettlement') }}
                        </el-button>
                    </div>
                </div>
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"
                    ref="xTable1"
                    :height="maxHeight"
                    show-overflow
                    highlight-hover-row
                    :loading="loading"
                    show-footer-overflow
                    :footer-method="footerMethodDtl"
                    show-footer
                    :keyboard-config="{ isArrow: true, isDel: true, isedit: true }"
                    :row-class-name="rowChange"
                    :data="form.dtl"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="dtlenter"
                    :key="refushTable"
                    @checkbox-change="checkboxChangeEvent"
                    @checkbox-all="checkboxChangeEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="checkbox" width="50"></vxe-table-column>
                    <vxe-table-column type="seq" field="seq" width="70" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(1) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                        <span class="add_" v-if="scoped.$rowIndex == dtlIndex">
                            <!-- <i class="el-icon-circle-plus-outline" @click="adddtl"></i> -->
                            <i class="el-icon-remove-outline" @click="deldtl(scoped)"></i>
                        </span>
                            <span v-if="scoped.$rowIndex != dtlIndex">
                            <i style="font-style: normal">{{ scoped.seq }}</i>
                        </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in rkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                            v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select'
                        "
                        >
                            <template #header="{ column }" v-if="item.batch == 1">
                                <span>{{ column.title }}</span>
                                <el-dropdown trigger="click" :hide-on-click="flagFalse">
                                    <el-button
                                        class="batchBtn"
                                        type="primary"
                                        plain
                                        :disabled="isedit || item.column_disabled == 1"
                                        @click="batchclick"
                                    >批量
                                    </el-button
                                    >
                                    <el-dropdown-menu slot="dropdown" style="padding: 15px">
                                        <el-radio-group v-model="batchOption">
                                            <div style="display: flex">
                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="1">所有行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="2">选中行及以下行修改为</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="5">选中行修改为</el-radio>
                                                    </div>
                                                </div>

                                                <div style="margin-right: 10px">
                                                    <div style="">
                                                        <el-radio label="3">所有行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="4">选中行及以下行加减</el-radio>
                                                    </div>
                                                    <div style="">
                                                        <el-radio label="6">选中行加减</el-radio>
                                                    </div>
                                                </div>
                                            </div>
                                        </el-radio-group>
                                        <div style="padding-top: 5px"></div>
                                        <el-form :inline="true">
                                            <el-form-item label="">
                                                <vxe-input
                                                    style="width: 280px"
                                                    :type="item.column_type"
                                                    v-model="batchSelect"
                                                    @blur="batchOperation($event, column.property, 'dtlTable')"
                                                ></vxe-input>
                                            </el-form-item>
                                        </el-form>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type, 'dtlTable')"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                            <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''), 'dtl')"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    :disabled="item.column_disabled == 1"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        v-if="shouldFilterOptions(item.field) ? option.gold_style_no && option.silver_style_no : true"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                    </template>

                    <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                    </template>
                </vxe-table>
            </div>
            <!-- 物料明细表格 -->
            <div class="table1 bom_dtl" v-if="systemSet.isBarcodesAssembly == 1">
                <div class="title">
                    <p>物料明细</p>
                </div>
                <vxe-table
                    border
                    stripe
                    resizable
                    keep-source
                    align="center"
                    ref="bomTable"
                    :height="maxHeight"
                    show-footer
                    :footer-method="footerMethodBom"
                    show-overflow
                    highlight-hover-row
                    :loading="loading"
                    :row-class-name="rowChange"
                    :data="form.bom"
                    :mouse-config="{ selected: true }"
                    :edit-config="{ trigger: 'click', mode: 'row', icon: 'fa fa', activeMethod: activeRowMethod }"
                    :keyboard-config="{ isArrow: true, isDel: true, isedit: true }"
                    :key="refushTable"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="seq" field="seq" width="70" title="序号">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(4) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span><i style="font-style: normal">{{ scoped.seq }}</i></span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in bmbKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                            name: 'input',
                            attrs: { type: item.column_type },
                            autoselect: true,
                            autofocus: '.vxe-input--inner'
                        }"
                            v-if="
                            item.column_status == 1 &&
                            item.column_type != 'select'
                        "
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type, 'bomTable')"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                            <span>{{
                                    $selectLable.selectLable(
                                        row[item.field],
                                        allArr[item.field.replace('_no', '')],
                                        item.field,
                                        item.field.replace('_no', '_name')
                                    )
                                }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    :disabled="item.column_disabled == 1"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                        option[item.field.replace('_no', '') + '_name']
                                    }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                    </template>

                    <template #empty>
                    <span style="color: red">
                        <img src="../../../assets/img/dontHave.png" style="width: 200px" />
                    </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <div class="table_warpper" @mouseleave="billleave">
            <!-- 账款明细表格 -->
            <div class="table2 table1">
                <div class="title">
                    <p>{{ $t('common.accountDetail') }}</p>
                </div>
                <vxe-table
                    height="320"
                    :data="form.bill"
                    ref="billTable"
                    :row-class-name="rowChange"
                    resizable
                    stripe
                    :auto-resize="true"
                    :footer-method="footerMethodBill"
                    show-footer
                    footer-row-class-name="footclass"
                    border
                    @cell-mouseenter="billenter"
                    :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                    :mouse-config="{ selected: true }"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isedit: true, enterToTab: true }"
                    @edit-closed="editClosedEvent"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="seq" width="70" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(2) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.seq == billIndex">
                                <i class="el-icon-circle-plus-outline" @click="addbill"></i>
                                <i class="el-icon-remove-outline" @click="delbill(scoped)"></i>
                            </span>
                            <span v-if="scoped.seq != billIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in zkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="
                                item.column_status == 1 &&
                                item.column_type != 'select'
                            "
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type, 'billTable')"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            allArr[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column>
                    </template>

                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
            <!-- 收付款表格 -->
            <div class="table3 table1" @mouseleave="amtleave">
                <div class="title">
                    <p>{{ $t('common.paymentDetail') }}</p>
                </div>
                <vxe-table
                    height="320"
                    :data="form.amt"
                    ref="amtTable"
                    :footer-method="footerMethodAmt"
                    :row-class-name="rowChange"
                    show-footer
                    resizable
                    stripe
                    :auto-resize="true"
                    border
                    :edit-config="{ trigger: 'click', mode: 'cell', icon: 'fa fa', activeMethod: activeRowMethod }"
                    @cell-mouseenter="amtenter"
                    :mouse-config="{ selected: true }"
                    :keyboard-config="{ isArrow: true, isDel: true, isEnter: true, isTab: true, isedit: true, enterToTab: true }"
                    :scroll-y="{ enabled: true, gt: 50 }"
                >
                    <vxe-table-column type="seq" width="70" align="center">
                        <template slot="header">
                            <i class="el-icon-setting" @click.stop="isedit ? changeTable(3) : null"></i>
                        </template>
                        <template slot-scope="scoped">
                            <span class="add_" v-if="scoped.$rowIndex == amtIndex">
                                <i class="el-icon-circle-plus-outline" @click="addamt"></i>
                                <i class="el-icon-remove-outline" @click="delamt(scoped)"></i>
                            </span>
                            <span v-if="scoped.$rowIndex != amtIndex">
                                <i style="font-style: normal">{{ scoped.seq }}</i>
                            </span>
                        </template>
                    </vxe-table-column>

                    <template v-for="(item, index) in fkKeyList">
                        <vxe-table-column
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{
                                name: 'input',
                                attrs: { type: item.column_type },
                                autoselect: true,
                                autofocus: '.vxe-input--inner'
                            }"
                            v-if="item.column_status == 1 && item.column_type != 'select'"
                        >
                            <template v-slot:edit="{ row }">
                                <vxe-input
                                    type="text"
                                    @input="handleInput(row, item.field, item.column_type,'amtTable')"
                                    @keydown.native="jumptable($event, row, item.field)"
                                    v-model="row[item.field]"
                                    @blur="item.column_type == 'number' ? $vaildator.all(row, item.tofixed, item.field) : ''"
                                    :disabled="item.column_disabled == 1"
                                ></vxe-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                            v-if="item.column_status == 1 && item.column_type == 'select'"
                            :title="item.column_name"
                            :field="item.field"
                            :width="item.column_width"
                            :key="item.field + index"
                            :edit-render="{ autofocus: '.el-input__inner' }"
                        >
                            <template #default="{ row }">
                                <span>{{
                                        $selectLable.selectLable(
                                            row[item.field],
                                            allArr[item.field.replace('_no', '')],
                                            item.field,
                                            item.field.replace('_no', '_name')
                                        )
                                    }}</span>
                            </template>
                            <template v-slot:edit="{ row }">
                                <el-select
                                    size="mini"
                                    v-model="row[item.field]"
                                    ref="stylefocus"
                                    filterable
                                    default-first-option
                                    placeholder="请选择"
                                    @change="changeData(row, item.field.replace('_no', ''))"
                                    @keydown.native="jumptable($event, row, item.field)"
                                >
                                    <el-option
                                        v-for="option in allArr[item.field.replace('_no', '')] || []"
                                        :key="option[item.field.replace('_no', '') + '_no']"
                                        :label="`${option[item.field.replace('_no', '') + '_no']} - ${
                                            option[item.field.replace('_no', '') + '_name']
                                        }`"
                                        :value="option[item.field.replace('_no', '') + '_no']"
                                        :disabled="option.status == 0"
                                    ></el-option>
                                </el-select>
                            </template>
                        </vxe-table-column
                        >
                    </template>

                    <template #empty>
                        <span style="color: red">
                            <img src="@/assets/img/dontHave.png" style="width: 200px" />
                        </span>
                    </template>
                </vxe-table>
            </div>
        </div>
        <!-- 页脚表单 -->
        <div class="footer">
            <el-form :inline="true">
                <div>
                    <el-form-item :label="$t('common.totalQty') + '：'">
                        <p>{{ form.sumqty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledQty') + '：'">
                        <p>{{ form.balprc_qty }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledQty') + '：'">
                        <p>{{ form.tran_qty }}</p>
                    </el-form-item>
                    <!-- <el-form-item label="金料重量：">
                        <p>{{ form.gold_sale_wgt }}</p>
                    </el-form-item>
                    <el-form-item label="银料重量：">
                        <p>{{ form.silver_sale_wgt }}</p>
                    </el-form-item> -->

                    <el-form-item :label="$t('common.payableAmt') + '：'">
                        <p>{{ form.sumamt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.unroundedAmt') + '：'">
                        <p>{{ form.sumamt2 }}</p>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item :label="$t('common.totalWeight') + '：'">
                        <p>{{ form.sumwgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.priceSettledWeight') + '：'">
                        <p>{{ form.balqty_wgt }}</p>
                    </el-form-item>
                    <el-form-item :label="$t('common.materialSettledWeight') + '：'">
                        <p>{{ form.tran_wgt }}</p>
                    </el-form-item>
                    <!-- <el-form-item label="金料金额：">
                        <p>{{ form.gold_amt }}</p>
                    </el-form-item>
                    <el-form-item label="银料金额：">
                        <p>{{ form.silver_amt }}</p>
                    </el-form-item> -->
                    <el-form-item label="已收金额：">
                        <p>{{ form.settle_amt }}</p>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-button type="" size="mini" :disabled="isedit" @click="refreshData(form.id)" style="width: 73px">
                    {{ $t('common.cancel') }}
                </el-button>
                <el-button type="primary" :disabled="isedit" size="mini" @click="saveItSub">{{ $t('common.save') }}
                </el-button>
            </div>
        </div>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入明细" :visible.sync="showImpotDialog" width="45%" :before-close="handleCloses">
            <div class="importDialogCenter">
                <div class="centerItem leftItem" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <div class="centerItem">
                    <!--  action="http://grapi.tbrjy.com/api/importdtl_sepwgt" -->
                    <el-upload
                        class="upload-demo"
                        :on-error="uploadError"
                        :on-success="uploadSuccess"
                        :before-upload="imptBeforeUpload"
                        :show-file-list="false"
                        style="width: 100%"
                        :headers="headers"
                        drag
                        :action="this.$baseURL + 'importdtl_barcodesout'"
                        multiple
                        :data="uploadData"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" style="text-align: center" slot="tip">支持拓展名：.xlsx</div>
                    </el-upload>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">取 消</el-button>
                <el-button type="primary" @click="showImpotDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 打印弹出框 -->
        <el-dialog style="padding: 0 0 20px" :title="$t('common.print')" :visible.sync="printData.isshow" width="60%">
            <el-select v-model="query.model_name" placeholder="请选择模板" filterable clearable @change="selectPrints"
                       style="width: 150px">
                <el-option v-for="(item, index) in pullList.model" :key="index" :label="item.id + '-' + item.name"
                           :value="item.id">
                </el-option>
            </el-select>
            <div v-loading="loading" class="printBox" id="print" ref="print"
                 style="page-break-after: always; padding: 10px">
                <div v-for="(itemBig, index) in printList" style="margin-bottom: 0px" :key="index">
                    <div
                        style="display: flex; align-items: center; justify-content: center; margin-bottom: 5px"
                        v-if="DataDtl.company.is_show == 1"
                    >
                        <p class="company" v-if="systemSet.company"
                           :style="`font-size:${DataDtl.company.font_size}px;`">
                            {{ systemSet.company }}
                        </p>
                    </div>
                    <div v-if="DataDtl.title">
                        <div v-if="DataDtl.title.is_show == 1">
                            <p class="printTitle" :style="`font-size:${DataDtl.title.font_size}px;`">
                                {{ itemBig.mains ? itemBig.mains.billtype_name : '' }}
                            </p>
                        </div>
                    </div>
                    <div v-if="DataDtl.header">
                        <div v-if="DataDtl.header.is_show == 1">
                            <div class="printTop" style="margin: 5px 0 10px; padding-bottom: 5px">
                                <div>
                                    <div v-if="DataDtl.custno.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户编号：{{ itemBig.mains ? itemBig.mains.cust_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.custname.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        客户：{{ itemBig.mains ? itemBig.mains.cust_name : '' }}
                                    </div>
                                    <div v-if="DataDtl.counterno.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台编号：{{ itemBig.mains ? itemBig.mains.counter_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.countername.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        柜台：{{ itemBig.mains ? itemBig.mains.counter_name : '' }}
                                    </div>
                                    <div v-if="DataDtl.billremark.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        备注：{{ itemBig.mains ? itemBig.mains.remark : '' }}
                                    </div>
                                </div>
                                <div>
                                    <div v-if="DataDtl.billno.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据编号：{{ itemBig.mains ? itemBig.mains.bill_no : '' }}
                                    </div>
                                    <div v-if="DataDtl.billdate.is_show == 1"
                                         :style="`font-size:${DataDtl.header.font_size}px;`">
                                        单据日期：{{ itemBig.mains ? itemBig.mains.bill_date : '' }}
                                    </div>
                                    <!--                                    <div v-if="DataDtl.printdate.is_show == 1" :style="`font-size:${DataDtl.header.font_size}px;`">-->
                                    <!--                                        打印时间：{{ itemBig.mains.print_time }}-->
                                    <!--                                    </div>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="itemBig.dtls.length != [] && DataDtl.is_fields1 == 1"
                        :style="`margin-bottom:${DataDtl.table1_bottommargin}px;`"
                    >
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <p class="tableName">
                                <span v-if="DataDtl.table_name1_show == 1">{{ DataDtl.table_name1 }}</span>
                            </p>
                            <p v-if="DataDtl.printdate.is_show == 1"
                               :style="`font-size:${DataDtl.header.font_size}px;`">
                                <label>打印时间：</label>{{ itemBig.mains.print_time }}
                            </p>
                        </div>
                        <table :border="DataDtl.is_fields1_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields1">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtls" :key="index">
                                <template v-for="items in fields1">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table1_total_show == 1">
                                <template v-for="(items, indexs) in fields1">
                                    <template v-if="indexs == 0"
                                    >
                                        <td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td>
                                    </template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields1_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtls_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="itemBig.dtlGroupBy && DataDtl.is_fields3 == 1"
                         :style="`margin-bottom:${DataDtl.table3_bottommargin}px;`">
                        <p class="tableName">
                            <span v-if="DataDtl.table_name3_show == 1">{{ DataDtl.table_name3 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields3_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields3">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.dtlGroupBy" :key="index">
                                <template v-for="items in fields3">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table3_total_show == 1">
                                <template v-for="(items, indexs) in fields3">
                                    <template v-if="indexs == 0"
                                    >
                                        <td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td>
                                    </template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields3_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.dtlGroupBy_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div
                        v-if="itemBig.bills.length != [] && DataDtl.is_fields2 == 1"
                        :style="`margin-bottom:${DataDtl.table2_bottommargin}px;`"
                    >
                        <p class="tableName">
                            <span v-if="DataDtl.table_name2_show == 1">{{ DataDtl.table_name2 }}</span>
                        </p>
                        <table :border="DataDtl.is_fields2_frame == 1 ? '1' : '0'" cellpadding="0" cellspacing="0">
                            <tr align="center">
                                <template v-for="item in fields2">
                                    <template v-if="item.is_show == 1">
                                        <th
                                            :style="`width:${item.size}px;font-size:${item.font_size}px;text-align:${item.align};border:${
                                                DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'
                                            }`"
                                            :key="item.seq"
                                        >
                                            {{ item.ename && item.ename.trim() !== '' ? item.ename : item.name }}
                                        </th>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-for="(item, index) in itemBig.bills" :key="index">
                                <template v-for="items in fields2">
                                    <template v-if="items.is_show == 1">
                                        <td
                                            v-if="items.no == 'style_name'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no] : '-' }}
                                        </td>
                                        <td
                                            v-else-if="items.no == 'bill_mode'"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            {{ item ? item[items.no + '_name'] : '-' }}
                                        </td>
                                        <td
                                            v-else
                                            :key="items.seq"
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                        >
                                            {{ item[items.no] || '-' }}
                                        </td>
                                    </template>
                                </template>
                            </tr>
                            <tr align="center" v-if="DataDtl.table2_total_show == 1">
                                <template v-for="(items, indexs) in fields2">
                                    <template v-if="indexs == 0"
                                    >
                                        <td
                                            :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                items.align
                                            };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                            :key="items.seq"
                                        >
                                            合计
                                        </td>
                                    </template
                                    >
                                    <template v-else>
                                        <template v-if="items.is_show == 1">
                                            <td
                                                :style="`width:${items.size}px;font-size:${items.font_size}px;text-align:${
                                                    items.align
                                                };border:${DataDtl.is_fields2_frame == 1 ? '1px solid #000' : '0px solid white'}`"
                                                :key="items.seq"
                                            >
                                                {{ itemBig.bills_total[items.no] || '-' }}
                                            </td>
                                        </template>
                                    </template>
                                </template>
                            </tr>
                        </table>
                    </div>
                    <div v-if="DataDtl.is_tot">
                        <div v-if="DataDtl.is_tot.is_show == 1">
                            <div class="summoney">
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                    >总计 金额大写 {{ itemBig.mains.money_type }}</span
                                    >
                                    <span
                                        :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money_chinese
                                        }}</span>
                                </div>
                                <div class="sum1">
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`"
                                    >金额合计&nbsp;&nbsp;&nbsp; {{ itemBig.mains.money_type }}</span
                                    >
                                    <span :style="`font-size:${DataDtl.is_tot.font_size}px;`">{{ itemBig.mains.money
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--                    <div v-if="DataDtl.custaccounts_begin">-->
                    <!--                        <div-->
                    <!--                            class="sum2"-->
                    <!--                            v-if="DataDtl.custaccounts_begin.is_show == 1"-->
                    <!--                            :style="`font-size:${DataDtl.custaccounts_begin.font_size}px;`"-->
                    <!--                        >-->
                    <!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期初存欠帐（正欠负存）:</span>-->
                    <!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
                    <!--                                <p-->
                    <!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
                    <!--                                    v-for="(item, index) in itemBig.custaccounts_begin"-->
                    <!--                                    :key="index"-->
                    <!--                                >-->
                    <!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
                    <!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
                    <!--                                </p>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div v-if="DataDtl.custaccounts_end">-->
                    <!--                        <div-->
                    <!--                            class="sum2"-->
                    <!--                            v-if="DataDtl.custaccounts_end.is_show == 1"-->
                    <!--                            :style="`font-size:${DataDtl.custaccounts_end.font_size}px;`"-->
                    <!--                        >-->
                    <!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">期末存欠帐（正欠负存）:</span>-->
                    <!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
                    <!--                                <p-->
                    <!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
                    <!--                                    v-for="(item, index) in itemBig.custaccounts_end"-->
                    <!--                                    :key="index"-->
                    <!--                                >-->
                    <!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
                    <!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
                    <!--                                </p>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->
                    <!--                    <div v-if="DataDtl.custaccounts_now">-->
                    <!--                        <div-->
                    <!--                            class="sum2"-->
                    <!--                            v-if="DataDtl.custaccounts_now.is_show == 1"-->
                    <!--                            :style="`font-size:${DataDtl.custaccounts_now.font_size}px;`"-->
                    <!--                        >-->
                    <!--                            <span style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">本期存欠帐（正欠负存）:</span>-->
                    <!--                            <div style="display: flex; flex-wrap: wrap; width: 80%">-->
                    <!--                                <p-->
                    <!--                                    style="width: 25%; display: flex; justify-content: space-between"-->
                    <!--                                    v-for="(item, index) in itemBig.custaccounts_now"-->
                    <!--                                    :key="index"-->
                    <!--                                >-->
                    <!--                                    <span style="margin-right: 10px">{{ item.style_name }}</span>-->
                    <!--                                    <span style="font-weight: normal">{{ item.value }}</span>-->
                    <!--                                </p>-->
                    <!--                            </div>-->
                    <!--                        </div>-->
                    <!--                    </div>-->

                    <div v-if="DataDtl.custaccounts_begin || DataDtl.custaccounts_end || DataDtl.custaccounts_now">
                        <div
                            class="sum2"
                            v-for="(accountConfig, index) in sortedCustAccounts"
                            :key="index"
                            v-if="accountConfig && accountConfig.is_show == 1"
                            :style="`font-size:${accountConfig.font_size}px;`"
                        >
                            <span
                                style="color: rgb(7, 16, 114); border-right: 0; font-weight: bold">{{ accountConfig.label
                                }}:</span>
                            <div style="display: flex; flex-wrap: wrap; width: 80%">
                                <p style="width: 25%; display: flex; justify-content: space-between"
                                   v-for="(item, itemIndex) in itemBig[accountConfig.dataKey]"
                                   :key="itemIndex"
                                >
                                    <span style="margin-right: 10px">{{ item.style_name }}</span>
                                    <span style="font-weight: normal">{{ item.value }}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div v-if="DataDtl.footer">
                        <div style="display: flex; align-items: center; justify-content: space-between">
                            <div class="sumBotn" style="width: 72%; margin-right: 8%">
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>制单：</span>
                                    <span>{{ itemBig.mains.build_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>复核：</span>
                                    <span></span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>业务员：</span>
                                    <span>{{ itemBig.mains.salesman_name || '' }}</span>
                                </div>
                                <div :style="`font-size:${DataDtl.footer.font_size}px;`"
                                     v-show="DataDtl.footer.is_show == 1">
                                    <span>客户签名：</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: right;">
                        <big-name v-if="DataDtl.tbrjphone_show == 1"></big-name>
                    </div>
                    <div v-if="DataDtl.remark.is_show == 1">
                        <p :style="`font-size:${DataDtl.remark.font_size}px; white-space: pre-wrap; word-wrap: break-word;`">
                            {{ DataDtl.remark.content }}</p>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="toImg">转图片下载</el-button>
                <el-button type="primary" @click="printContext">直接打印</el-button>
                <el-button @click="printData.isshow = false">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 列表配置 -->
        <el-drawer title="我是标题" :visible.sync="drawers" :direction="direction" :with-header="false"
                   destroy-on-close>
            <div class="filterKey_box">
                <div class="box_header">
                    <span>列配置</span>
                    <i class="el-icon-close icon" @click="drawers = false"></i>
                </div>
                <div class="box_content">
                    <div class="small_box">
                        <div class="text">
                            <span class="big">已显示字段</span>
                            <span class="small">拖动可调整字段顺序</span>
                        </div>
                        <ul class="ul">
                            <draggable
                                :list="keyList"
                                class="list-group"
                                ghost-class="ghost"
                                :move="checkMove"
                                animation="1000"
                                force-fallback="true"
                                chosen-class="chosen"
                            >
                                <li
                                    class="li"
                                    v-for="(item, index) in keyList"
                                    :key="index"
                                    v-show="item.column_status == 1"
                                    @mouseover="showIndex = index"
                                    @mouseleave="showIndex = null"
                                >
                                    <i class="el-icon-s-grid icon"></i>
                                    {{ item.column_name }}
                                    <i class="el-icon-error delIcon" v-show="showIndex == index"
                                       @click="liClick('del', item, index)"></i>
                                </li>
                            </draggable>
                        </ul>
                    </div>
                    <div class="small_box">
                        <div class="text">
                            <span class="big">可选字段</span>
                            <span class="small"></span>
                        </div>
                        <ul class="ul">
                            <draggable :list="keyList" :disabled="true" class="list-group" ghost-class="ghost"
                                       :move="checkMove">
                                <transition-group>
                                    <li
                                        class="li hover"
                                        v-for="(item, index) in keyList"
                                        :key="index"
                                        v-show="item.column_status == 0 && item.field_status == 1"
                                        @mouseover="optionalIndex = index"
                                        @mouseleave="optionalIndex = null"
                                        @click="liClick('add', item, index)"
                                    >
                                        <i class="el-icon-circle-plus-outline icon2"
                                           v-show="optionalIndex == index"></i>
                                        {{ item.column_name }}
                                    </li>
                                </transition-group>
                            </draggable>
                        </ul>
                    </div>
                    <div class="box_btn">
                        <el-button @click="keycancel" style="font-size: 14px">{{ $t('common.cancel') }}</el-button>
                        <el-button @click="keyConfirm" type="primary" style="font-size: 14px">{{ $t('common.confirm')
                            }}
                        </el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <!-- 批量扫码 -->
        <!-- <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleCloses">
            <div v-if="insertKeywords.length != 0">数量:{{ insertKeywords.length }}</div>
            <el-select
                style="margin-bottom: 50px"
                v-model="insertKeywords"
                placeholder="请选择"
                allow-create
                multiple
                filterable
                clearable
                @keydown.native.enter="insertTableBcode('select', $event)"
            >
                <el-option
                    style="width: 130px; height: 80px"
                    v-for="item in allArr.specs"
                    :key="item"
                    :label="item"
                    :value="item"
                ></el-option>
            </el-select>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="specschange(insertKeywords)">确 定</el-button>
            </span>
        </el-dialog> -->
        <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleCloses">
            <!-- 显示标签数量 -->
            <div v-if="dynamicTags.length !== 0">数量: {{ dynamicTags.length }}</div>

            <!-- 标签显示区域 -->
            <el-tag v-for="tag in dynamicTags" :key="tag" closable :disable-transitions="false"
                    @close="handleClose(tag)" effect="plain">
                {{ tag }}
            </el-tag>

            <!-- 输入框区域 -->
            <input
                style="width: 200px"
                class="el-textarea__inner"
                v-model.lazy="inputValuepl"
                ref="saveTagInput"
                size="small"
                @keyup.enter="handleInputConfirm"
                @blur="handleInputConfirm"
            />
            <!-- <el-button v-else class="button-new-tag" size="small" @click="showInput" ref="newTagButton"> + New Tag </el-button> -->

            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="specschange(dynamicTags)">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="提示" :visible.sync="showImpotDialogsb" width="25%" :before-close="handleClose">
            <el-form label-width="80px">
                <el-form-item label="设备">
                    <el-select
                        style="margin-bottom: 50px; width: 80%"
                        v-model="insertAllData"
                        placeholder="请选择"
                        multiple
                        filterable
                        clearable
                    >
                        <el-option v-for="item in allArrData" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialogsb = false">取 消</el-button>
                <el-button type="primary" @click="closingTrue">确 定</el-button>
            </span>
        </el-dialog>

        //批量修改字段弹窗
        <el-dialog title="批量修改字段" :visible.sync="UpFieldDialogStatus" width="520px"
                   :before-close="closeUpFieldDialog" custom-class="batch-field-dialog">
            <div class="batch-field-content">
                <div class="batch-field-section">
                    <div class="batch-field-label">
                        <i class="el-icon-document"></i>
                        <span>选择字段</span>
                        <el-checkbox
                            class="select-all-checkbox"
                            :indeterminate="multipleSelectionField.length > 0 && multipleSelectionField.length < fieldDialogData.length"
                            :value="multipleSelectionField.length === fieldDialogData.length && fieldDialogData.length > 0"
                            @change="toggleSelectAllField"
                        >全选
                        </el-checkbox>
                    </div>
                    <div class="checkbox-row">
                        <el-checkbox-group v-model="multipleSelectionField" @change="handleSelectionChangeField">
                            <div class="checkbox-item" v-for="(item, index) in fieldDialogData" :key="index">
                                <el-checkbox :label="item.field">{{ item.column_name }}</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="batch-field-section">
                    <div class="batch-field-label">
                        <i class="el-icon-edit"></i>
                        <span>修改数值</span>
                    </div>
                    <el-input-number
                        v-model="batchFieldValue"
                        :precision="4"
                        :step="0.01"
                        controls-position="right"
                        placeholder="请输入数值"
                        style="width: 100%"
                    ></el-input-number>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeUpFieldDialog">取 消</el-button>
                <el-button type="primary"
                           :disabled="multipleSelectionField.length === 0 || batchFieldValue === null || batchFieldValue === undefined"
                           @click="confirmBatchUpdateField">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { multiplication, multiplication2, getExportExcel, messageShow } from '@/utils/multAdexportExcel.js';
import {
    apiBarcodesoutGetData,
    apiBarcodesoutGetPull,
    apiBarcodesoutUpdateData,
    apiBarcodesoutAddData,
    apiBarcodesoutDelData,
    apiBarcodesoutcheck,
    apiBarcodesoutIsAllowUp,
    apiBarcodesoutPriceAdMate,
    apiBarcodesoutgetBarcode,
    apiBarcodesoutRfidPull,
    apiBarcodesoutRfidData,
    apiCurrentPermisson,
    apiSystem,
    apiGetDividedBtnInfo,
    apiIsOrderQuote,
    insjQuitSum,
    apiGetListCorrespondingData,
    apiUpdateListCorrespondingData,
    apiBarcodesoutTempPrint,
    apiBarcodesoutgetBillno,
    getPrinOut_pull
} from '@/request/api';
import { translateColumns } from '@/utils/columnI18n';

export default {
    name: 'barcodesout',
    data() {
        return {

            dtlAmtTotal: 0,
            billAmtTotal: 0,
            bomAmtTotal: 0,

            UpFieldDialogStatus: false,
            multipleSelectionField: [],
            fieldDialogData: [],
            batchFieldValue: null,
            allArrData: [],
            insertAllData: [],
            showImpotDialogsb: false,
            dynamicTags: [], // 存储标签的数组
            inputVisible: false, // 控制输入框的显示与隐藏
            inputValuepl: '', // 输入框的值
            query: {},
            dialogVisible: false,
            wgtTotal: 0,
            allArr: '',
            form: { remark: '', bom: [] },
            isedit: true,
            isCheck: false,
            first: null,
            last: null,
            dialogImageUrl: '',
            isAdd: false,
            loading: false,
            nullBtn: false,
            systemSet: '',
            dtlIndex: '-1', //列表当前位置,
            isSave: true,
            type: '4',
            maxHeight: 480,
            showImpotDialog: false,
            headers: {},
            topIptInsjOrder: '',
            topLeftForm: {},
            billIndex: '-1',
            amtIndex: '-1',
            insertKeyword: '',
            insertKeywords: [],
            insertBillno: '',
            // 防抖
            debounceTimeout: null, // 用于存储防抖定时器
            // 批量字段
            batchSelect: '',
            selectRecords: 0,
            batchOption: '1',
            flagFalse: false,
            //列表擦操作字段
            keyList: [],
            drawers: false,
            direction: 'rtl',
            showIndex: null,
            optionalIndex: null,
            refushTable: true,
            rkKeyList: [],
            zkKeyList: [],
            fkKeyList: [],
            bmbKeyList: [],
            originalRkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalZkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalFkKeyList: [], // 保存原始的列配置（包含所有语言）
            originalBmbKeyList: [], // 保存原始的列配置（包含所有语言）
            keyStatus: '74',
            perData: {}, //权限

            // 打印字段
            printData: { isshow: false, scope: null, index: 0, data: {} },
            DataDtl: { is_cunqian: {}, is_tot: {}, remark: {}, company: {} },
            fields3: [],
            fields2: [],
            fields1: [],
            query: {},
            pullList: {},
            printList: {},
            uploadData: {}
        };
    },
    computed: {
        sortedCustAccounts() {
            const accounts = [];

            if (this.DataDtl.custaccounts_begin) {
                accounts.push({
                    dataKey: 'custaccounts_begin',
                    label: '期初存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_begin.seq || 1,
                    is_show: this.DataDtl.custaccounts_begin.is_show,
                    font_size: this.DataDtl.custaccounts_begin.font_size
                });
            }

            if (this.DataDtl.custaccounts_end) {
                accounts.push({
                    dataKey: 'custaccounts_end',
                    label: '期末存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_end.seq || 2,
                    is_show: this.DataDtl.custaccounts_end.is_show,
                    font_size: this.DataDtl.custaccounts_end.font_size
                });
            }

            if (this.DataDtl.custaccounts_now) {
                accounts.push({
                    dataKey: 'custaccounts_now',
                    label: '本期存欠帐（正欠负存）',
                    seq: this.DataDtl.custaccounts_now.seq || 3,
                    is_show: this.DataDtl.custaccounts_now.is_show,
                    font_size: this.DataDtl.custaccounts_now.font_size
                });
            }

            return accounts.sort((a, b) => a.seq - b.seq);
        }
    },
    mounted() {
        this.systemSet = JSON.parse(localStorage.getItem('systemSet'));
        this.getSystem();
        this.getStoneData();
        this.getPulls();
        this.getTable();
        this.getTable1();
        this.getTable2();
        this.getTable3();
        this.getPermission();
        document.addEventListener('keydown.native', this.mykeyup);
        // this.geData();
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        if (this.$route.query.isadd == 0) {
            this.add();
        } else {
            this.geData();
        }
        // 监听语言变化
        this.$watch(
            () => this.$i18n ? this.$i18n.locale : localStorage.getItem('language'),
            (newLang) => {
                // 语言变化时，重新转换列名
                if (this.originalRkKeyList && this.originalRkKeyList.length > 0) {
                    this.rkKeyList = translateColumns(this.originalRkKeyList, newLang || 'zh-CN');
                }
                if (this.originalZkKeyList && this.originalZkKeyList.length > 0) {
                    this.zkKeyList = translateColumns(this.originalZkKeyList, newLang || 'zh-CN');
                }
                if (this.originalFkKeyList && this.originalFkKeyList.length > 0) {
                    this.fkKeyList = translateColumns(this.originalFkKeyList, newLang || 'zh-CN');
                }
                if (this.originalBmbKeyList && this.originalBmbKeyList.length > 0) {
                    this.bmbKeyList = translateColumns(this.originalBmbKeyList, newLang || 'zh-CN');
                }
            }
        );
    },
    activated() {
        // if (this.$route.query.isadd == 0) {
        //     this.add();
        // } else {
        //     this.geData();
        // }
        let bill_no = this.$route.query.bill_no;
        if (bill_no) {
            this.geData();
        }
    },
    methods: {
        //=========== 【Begin】 ==============================
        handleSelectionChangeField(val) {
            this.multipleSelectionField = val;
        },
        toggleSelectAllField(val) {
            if (val) {
                this.multipleSelectionField = this.fieldDialogData.map(item => item.field);
            } else {
                this.multipleSelectionField = [];
            }
        },
        showUpFieldDialog() {
            this.fieldDialogData = this.rkKeyList.filter(item => item.field_status == 1 && item.column_disabled == 0 && item.column_type == 'number' && item.tofixed == 'prc');
            this.multipleSelectionField = [];
            this.batchFieldValue = null;
            this.UpFieldDialogStatus = true;
        },
        closeUpFieldDialog() {
            this.UpFieldDialogStatus = false;
            this.batchFieldValue = null;
            this.multipleSelectionField = [];
        },
        confirmBatchUpdateField() {
            if (this.multipleSelectionField.length === 0 || this.batchFieldValue === null || this.batchFieldValue === undefined) {
                this.$message.warning('请选择字段并输入数值');
                return;
            }
            // 获取选中字段的中文名称
            const selectedFieldNames = this.fieldDialogData
                .filter(item => this.multipleSelectionField.includes(item.field))
                .map(item => item.column_name)
                .join('、');
            const tableData = this.$refs.xTable1.getTableData().fullData;
            this.$confirm(
                `此操作将批量修改列表中 <b>${tableData.length}</b> 条货品的以下字段：<br/><b>${selectedFieldNames}</b><br/>修改值为：<b>${this.batchFieldValue}</b><br/><br/><span style="color: #E6A23C; font-size: 12px;">⚠ 修改后如需恢复为货品原有价格，需删除该记录后重新录入。</span>`,
                '批量修改确认',
                {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确认修改',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                for (let i = 0; i < tableData.length; i++) {
                    for (let j = 0; j < this.multipleSelectionField.length; j++) {
                        tableData[i][this.multipleSelectionField[j]] = this.batchFieldValue;
                    }
                    this.calculationDtlDtl(tableData[i]);
                }
                this.flagFalse = false;
                this.UpFieldDialogStatus = false;
                this.batchFieldValue = null;
                this.multipleSelectionField = [];
                this.$message.success('批量修改成功');
            }).catch(() => {
                // 用户取消操作
            });
        },
        //============= 【end】 ============================
        showImpotOpen() {
            if (!this.form.counter_no) {
                this.$message.error('请选择柜台');
            } else {
                this.showImpotDialogsb = true;
                apiBarcodesoutRfidPull({}).then((res) => {
                    if (res.code != 2000) {
                        this.$message.error(res.data.info);
                    } else {
                        this.allArrData = res.data.equipmentcode;
                    }
                });
            }
        },
        closingTrue() {
            if (this.insertAllData.length > 0) {
                apiBarcodesoutRfidData({
                    equipmentcode: this.insertAllData,
                    counter_no: this.form.counter_no
                }).then((res) => {
                    if (res.code == 2000) {
                        this.form.dtl = res.data.data;
                        this.insertAllData = [];
                        this.showImpotDialogsb = false;

                        this.messageShow(res);
                    } else {
                        this.showImpotDialogsb = false;

                        this.messageShow(res);
                    }
                });
            }
        },
        selectStore(e) {
        },
        selectCounter(e) {
        },
        shouldFilterOptions(field) {
            // 根据 field 或其他条件判断是否需要过滤
            return field == 'style_no'; // 替换为你的逻辑
        },
        batchclick() {
            this.batchSelect = '';
        },
        batchOperation(e, r, tableTab) {
            if (e.value) {
                var table1 = this.$refs.xTable1.getTableData().fullData;
                if (this.batchOption == '1') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '2') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = e.value;
                    }
                } else if (this.batchOption == '3') {
                    for (let i = 0; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '4') {
                    let selectedRowIndex = --this.selectRecords[0].seq;
                    for (let i = selectedRowIndex; i < table1.length; i++) {
                        table1[i][r] = Number(table1[i][r]) + Number(e.value);
                    }
                } else if (this.batchOption == '5') {
                    // 处理多个选中的行修改为指定值
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            table1[selectedRowIndex][r] = e.value; // 修改选中行的指定列值
                        }
                    }
                } else if (this.batchOption == '6') {
                    // 处理多个选中的行加减
                    for (let i = 0; i < this.selectRecords.length; i++) {
                        let selectedRowIndex = --this.selectRecords[i].seq;
                        if (selectedRowIndex >= 0 && selectedRowIndex < table1.length) {
                            // 对选中行进行加减
                            table1[selectedRowIndex][r] = Number(table1[selectedRowIndex][r]) + Number(e.value);
                        }
                    }
                }
                for (let i = 0; i < table1.length; i++) {
                    if (tableTab == 'dtlTable') {
                        this.calculationDtlDtl(table1[i]);
                    }
                    if (tableTab == 'billTable') {
                        this.calculationBillDtl(table1[i]);
                    }
                }
                this.flagFalse = false;
            }
        },
        checkboxChangeEvent({ records }) {
            this.selectRecords = records;
        },
        async insertCBillno(e) {
            const v = e.target.value.trim(); // 去除空格
            if (v) {
                if (e.keyCode == 16 || e.keyCode == 13) {
                    // 只处理回车键
                    clearTimeout(this.debounceTimeout); // 清除上一个定时器

                    this.debounceTimeout = setTimeout(async () => {
                        // 检查输入值是否重复
                        const isDuplicate = this.$refs.xTable1.getTableData().fullData.some((row) => row.related_bill_no === v);
                        if (isDuplicate) {
                            this.$message.error('输入的关联单号不能重复。');
                            this.insertBillno = '';
                            return;
                        }

                        try {
                            const res = await apiBarcodesoutgetBillno({
                                bill_no: v,
                                counter_no: this.form.counter_no,
                                store_no: this.form.store_no
                            });
                            // const tableData = this.$refs.xTable1.getTableData().fullData;
                            if (res.code == 2000) {
                                // 接口返回的data已改为product和bom两个数组，分别对应明细表格数据和物料数据
                                const product = (res.data.data && res.data.data.product) || [];
                                const bom = (res.data.data && res.data.data.bom) || [];
                                this.insertBillno = ''; // 清空输入框
                                // records.forEach((record) => {
                                //     // 查找现有条目
                                //     const existingIndex = tableData.findIndex((item) => item.barcode === record.barcode);

                                //     if (existingIndex !== -1) {
                                //         // 如果存在，更新该条目
                                //         this.$set(tableData, existingIndex, { ...record });
                                //     } else {
                                //         // 如果不存在，插入新条目
                                //         tableData.push({ ...record });
                                //     }
                                // });

                                this.$refs.xTable1.reloadData(Array.isArray(product) ? product : [product]);
                                // 物料明细表格数据追加
                                if (!this.form.bom) {
                                    this.$set(this.form, 'bom', []);
                                }
                                this.$set(this.form, 'bom', [...this.form.bom, ...(Array.isArray(bom) ? bom : [])]);
                                this.messageShow(res);
                            } else {
                                this.$message.error(res.data.info);
                                this.insertBillno = '';
                            }
                        } catch (res) {
                            console.error('请求失败:', res);
                            this.$message.error('请求失败，请重试。');
                        }
                    }, 300); // 设置防抖延迟时间
                }
            }
        },
        // handleKeyDown(e) {
        //     console.log(e, 'e');
        //     // 防止在输入框为空时触发
        //     if (!this.insertKeyword.trim()) return;

        //     // 防抖：清除上一次的定时器
        //     clearTimeout(this.debounceTimeout);

        //     // 设置新的定时器
        //     this.debounceTimeout = setTimeout(() => {
        //         // 执行插入表格的函数
        //         this.insertTableBcode(e);
        //     }, 300); // 延迟时间：300ms
        // },
        dialogTrueFalse() {
            if (!this.form.counter_no) {
                this.$message.error('请选择柜台');
            } else {
                const isDuplicate = this.$refs.xTable1.getTableData().fullData.map((row) => row.barcode);
                this.insertKeywords = isDuplicate;
                this.dialogVisible = true;
            }
        },
        async insertTableBcode(type, e) {
            const v = e.target.value.trim(); // 去除空格

            if (type == 'select') {
                const inputValue = e.target.value;

                const isDuplicate = this.$refs.xTable1.getTableData().fullData.some((row) => row.barcode === inputValue);
                if (isDuplicate) {
                    this.$message.error('输入的条码不能重复。');
                    this.insertKeywords.push();
                    return;
                } else {
                    if (inputValue && !this.insertKeywords.includes(inputValue)) {
                        this.insertKeywords.push(inputValue);
                    } else {
                        this.insertKeywords.push();
                    }
                }
                // this.$forceUpdate();
            } else {
                if (v) {
                    if (e.keyCode == 16 || e.keyCode == 13) {
                        // 只处理回车键
                        clearTimeout(this.debounceTimeout); // 清除上一个定时器

                        this.debounceTimeout = setTimeout(async () => {
                            // 检查输入值是否重复
                            const isDuplicate = this.$refs.xTable1.getTableData().fullData.some((row) => row.barcode === v);
                            if (isDuplicate) {
                                this.$message.error('输入的条码不能重复。');
                                this.insertKeyword = '';
                                return;
                            }

                            try {
                                const res = await apiBarcodesoutgetBarcode({
                                    barcode: v.split(','),
                                    counter_no: this.form.counter_no,
                                    store_no: this.form.store_no
                                });

                                if (res.code == 2000) {
                                    // 接口返回的data已改为product和bom两个数组，分别对应明细表格数据和物料数据
                                    const product = (res.data.data && res.data.data.product) || [];
                                    const bom = (res.data.data && res.data.data.bom) || [];
                                    const records = Array.isArray(product) ? product : [product];
                                    this.insertKeyword = ''; // 清空输入框
                                    records.forEach((record) => {
                                        this.$refs.xTable1.insertAt(record, -1);
                                    });
                                    // 物料明细表格数据追加
                                    if (!this.form.bom) {
                                        this.$set(this.form, 'bom', []);
                                    }
                                    this.$set(this.form, 'bom', [...this.form.bom, ...(Array.isArray(bom) ? bom : [])]);
                                    this.messageShow(res);
                                } else {
                                    this.$message.error(res.data.info);
                                    this.insertKeyword = '';
                                }
                            } catch (error) {
                                console.error('请求失败:', error);
                                this.$message.error('请求失败，请重试。');
                            }
                        }, 300); // 设置防抖延迟时间
                    }
                }
            }
        },
        // 显示输入框
        showInput() {
            this.inputVisible = true;
            this.$nextTick(() => {
                // 聚焦到输入框
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        // 处理输入确认
        handleInputConfirm() {
            const inputValue = this.inputValuepl.trim();
            clearTimeout(this.debounceTimeout); // 清除上一个定时器

            this.$nextTick(() => {
                this.$refs.saveTagInput.blur();
            });
            this.debounceTimeout = setTimeout(async () => {
                if (inputValue && !this.dynamicTags.includes(inputValue)) {
                    // 检查是否重复
                    let Idx = this.insertKeywords.findIndex((item) => {
                        return item == inputValue;
                    });

                    if (Idx != -1) {
                        this.$message.error('输入的条码不能重复。');
                    } else {
                        this.dynamicTags.push(inputValue);
                    }
                }
                this.inputValuepl = ''; // 清空输入框

                // 保持输入框显示并聚焦
                this.$nextTick(() => {
                    this.$refs.saveTagInput.focus();
                });
            }, 300);
        },

        // 处理标签关闭
        handleClose(tag) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        },

        // 处理确定按钮点击
        async specschange(tags) {
            if (tags.length < 1) {
                this.$message.error('暂无数据,请输入条码号');
                return;
            }
            clearTimeout(this.debounceTimeout);

            this.debounceTimeout = setTimeout(async () => {
                // 找到重复的条码
                const duplicateBarcodes = tags.filter((barcode) =>
                    this.$refs.xTable1.getTableData().fullData.some((row) => row.barcode === barcode)
                );

                if (duplicateBarcodes.length > 0) {
                    // 删除重复的条码
                    tags = tags.filter((barcode) => !duplicateBarcodes.includes(barcode));

                    // 提示用户哪些条码被删除
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: `以下条码重复并已被删除：${duplicateBarcodes.join(', ')}`
                    });

                    // 更新 dynamicTags
                    this.dynamicTags = [...tags];
                    if (this.dynamicTags.length === 0) return;
                }

                // 处理条码逻辑
                const tableData = this.$refs.xTable1.getTableData().fullData;
                try {
                    const res = await apiBarcodesoutgetBarcode({
                        barcode: this.dynamicTags,
                        counter_no: this.form.counter_no,
                        store_no: this.form.store_no
                    });

                    if (res.code === 2000) {
                        // 接口返回的data已改为product和bom两个数组，分别对应明细表格数据和物料数据
                        const product = (res.data.data && res.data.data.product) || [];
                        const bom = (res.data.data && res.data.data.bom) || [];
                        const records = Array.isArray(product) ? product : [product];
                        records.forEach((record) => {
                            const existingIndex = tableData.findIndex((item) => item.barcode === record.barcode);
                            if (existingIndex !== -1) {
                                this.$message.error('输入的条码不能重复。');
                            } else {
                                this.$refs.xTable1.insertAt(record, -1);
                            }
                        });
                        // 物料明细表格数据追加
                        if (!this.form.bom) {
                            this.$set(this.form, 'bom', []);
                        }
                        this.$set(this.form, 'bom', [...this.form.bom, ...(Array.isArray(bom) ? bom : [])]);
                        this.dynamicTags = [];
                        this.messageShow(res);
                    } else {
                        this.$message.error(res.data.info);
                        this.dynamicTags = [];
                    }
                    this.dialogVisible = false;
                } catch (error) {
                    this.dialogVisible = false;
                    console.error('请求失败:', error);
                    this.$message.error('请求失败，请重试。');
                }
            }, 300);
        },
        // specschange(v) {
        //     // 清除上一个定时器
        //     clearTimeout(this.debounceTimeout);

        //     // 设置新的定时器
        //     this.debounceTimeout = setTimeout(async () => {
        //         // 找到重复的条码
        //         const duplicateBarcodes = v.filter((barcode) =>
        //             this.$refs.xTable1.getTableData().fullData.some((row) => row.barcode === barcode)
        //         );

        //         if (duplicateBarcodes.length > 0) {
        //             // 删除重复的条码
        //             v = v.filter((barcode) => !duplicateBarcodes.includes(barcode));

        //             // 输出提示，告诉用户哪些条码被删除了
        //             this.$message({
        //                 type: 'error',
        //                 showClose: true,
        //                 duration: 0,
        //                 dangerouslyUseHTMLString: true,
        //                 message: `以下条码重复并已被删除：${duplicateBarcodes.join(', ')}`
        //             });
        //             // 可以将清理后的条码更新到相关的数据结构
        //             this.insertKeywords = [...v]; // 假设需要更新 insertKeywords
        //             if (!this.insertKeywords.length > 0) {
        //                 return;
        //             }
        //         }
        //         // 如果没有重复条码，继续处理其他逻辑
        //         const tableData = this.$refs.xTable1.getTableData().fullData;
        //         try {
        //             const res = await apiBarcodesoutgetBarcode({
        //                 barcode: this.insertKeywords,
        //                 counter_no: this.form.counter_no,
        //                 store_no: this.form.store_no
        //             });

        //             if (res.code == 2000) {
        //                 const records = res.data.data; // 获取返回的数据
        //                 records.forEach((record) => {
        //                     // 查找现有条目
        //                     const existingIndex = tableData.findIndex((item) => item.barcode === record.barcode);
        //                     if (existingIndex !== -1) {
        //                         // 如果存在，更新该条目
        //                         this.$set(tableData, existingIndex, { ...record });
        //                     } else {
        //                         // 如果不存在，插入新条目
        //                         this.$refs.xTable1.insertAt(record, -1); // 确保每次只插入一条数据
        //                     }
        //                 });
        //                 this.insertKeywords = [];
        //                 this.messageShow(res);
        //             } else {
        //                 this.$message.error(res.data.info);
        //                 this.insertKeywords = [];
        //             }
        //             this.dialogVisible = false;
        //         } catch (error) {
        //             this.dialogVisible = false;
        //             console.error('请求失败:', error);
        //             this.$message.error('请求失败，请重试。');
        //         }
        //     }, 300); // 设置防抖延迟时间
        // },
        messageShow(res) {
            if (res.data.info instanceof Array) {
                let str = [];
                var s = '';
                str = res.data.info;
                for (let i = 0; i < str.length; i++) {
                    s += str[i] + '<br/>';
                }
                this.$message({
                    type: 'error',
                    showClose: true,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: s
                });
            } else {
                this.$message.success(res.data.info);
            }
        },
        selectCust(value) {
            if (value) {
                let item = this.allArr.cust.filter((item) => item.cust_no == value);
                this.$set(this.form, 'salesman_no', item[0].salesman_no);
                this.$forceUpdate();
            }
        },
        getPulls() {
            let path_code = this.$route.path.replace('/', '');
            getPrinOut_pull({ code: path_code }).then((res) => {
                this.pullList = res.data;
                this.query.model_name = this.pullList.model_data.id;
                this.printType = this.pullList.model_data.name;
            });
        },
        // 打印
        printOut() {
            this.getPulls();
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiBarcodesoutTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                console.log(res, 'aa');
                if (res.code == 2000) {
                    this.printData.isshow = true;
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields3 = this.DataDtl.fields3;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    this.$message.error(res.data.info);
                }
            });
        },

        // 选择打印下拉框-----------------------
        selectPrints(val) {
            let modelList = this.pullList.model;
            this.printType = modelList.find((item) => item.id == val).name;
            let id = modelList.find((item) => item.id == val).id;
            this.query.model_name = val;
            this.printOutTwo();
            this.$forceUpdate();
        },
        printOutTwo() {
            const loading = this.$loading({
                lock: true,
                text: '打印加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.5)'
            });
            apiBarcodesoutTempPrint({
                id: this.form.id,
                print_id: this.query.model_name
            }).then((res) => {
                if (res.code == 2000) {
                    loading.close();
                    this.printList = res.data.bill;
                    //模板打印数据
                    this.DataDtl = res.data.print;
                    this.fields3 = this.DataDtl.fields3;
                    this.fields2 = this.DataDtl.fields2;
                    this.fields1 = this.DataDtl.fields1;
                } else {
                    loading.close();
                    // this.$message.error(res.data.info);
                    this.printOut();
                }
            });
        },
        toImg() {
            this.$html2canvas(this.$refs.print, {
                backgroundColor: 'white',
                useCORS: true,
                windowHeight: document.body.scrollHeight
            }).then((canvas) => {
                let url = canvas.toDataURL();
                this.img = url;
                this.download();
            });
        },
        //下载图片
        download() {
            let imgData = this.img;
            this.downloadFile(this.printType + '.png', imgData);
        },
        //下载
        downloadFile(fileName, content) {
            let aLink = document.createElement('a');
            let blob = this.base64ToBlob(content); //new Blob([content]);

            let evt = document.createEvent('HTMLEvents');
            evt.initEvent('click', true, true); //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
            aLink.download = fileName;
            aLink.href = URL.createObjectURL(blob);
            aLink.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); //兼容火狐
        },
        //base64转blob
        base64ToBlob(code) {
            let parts = code.split(';base64,');
            let contentType = parts[0].split(':')[1];
            let raw = window.atob(parts[1]);
            let rawLength = raw.length;

            let uInt8Array = new Uint8Array(rawLength);

            for (let i = 0; i < rawLength; ++i) {
                uInt8Array[i] = raw.charCodeAt(i);
            }
            return new Blob([uInt8Array], { type: contentType });
        },
        printContext() {
            this.$print(this.$refs.print);
        },
        // 快捷键保存
        mykeyup(e) {
            var key = window.event.keyCode ? window.event.keyCode : window.event.which;
            if (key === 83 && e.ctrlKey) {
                // this.save('hot key');
                if (!this.isedit) {
                    if (this.$route.path == '/barcodesout') {
                        this.saveItSub();
                        e.preventDefault();
                        e.returnValue = false;
                    }
                }
            }
        },
        closingPrice(type) {
            let dtl = JSON.stringify(this.$refs.xTable1.getTableData().fullData);
            apiBarcodesoutPriceAdMate({
                type,
                dtl
            }).then((res) => {
                this.form.bill = res.data.bill;
                this.form.sumqty = res.data.all.sumqty;
                this.form.sumwgt = res.data.all.sumwgt;
                this.form.balprc_qty = res.data.all.balprc_qty;
                this.form.balqty_wgt = res.data.all.balqty_wgt;
                this.form.tran_wgt = res.data.all.tran_wgt;
                this.form.tran_qty = res.data.all.tran_qty;
                this.$forceUpdate();
                setTimeout(() => {
                    const $table = this.$refs.billTable;
                    $table.updateFooter();
                }, 100);
            });
        },
        amtenter(row) {
            if (!this.isedit) {
                this.amtIndex = row.$rowIndex;
            }
        },
        amtleave() {
            this.amtIndex = '-1';
        },
        billenter(row) {
            if (!this.isedit) {
                this.billIndex = row.seq;
            }
        },
        billleave() {
            this.billIndex = '-1';
        },
        handleCloses(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done();
                })
                .catch((_) => {
                });
        },

        // 上传文件之前的钩子
        imptBeforeUpload(f) {
            this.uploadData.store_no = this.form.store_no;
            this.uploadData.counter_no = this.form.counter_no;
            this.uploadData.cust_no = this.form.cust_no;
        },
        // 拖拽成功的钩子 导入
        uploadSuccess(res) {
            if (res.code == 2000) {
                // this.$message.success(res.msg);
                this.messageShow(res);
                // 接口返回的data已改为product和bom两个数组，分别对应明细表格数据和物料数据
                const product = (res.data && res.data.data && res.data.data.product) || [];
                const bom = (res.data && res.data.data && res.data.data.bom) || [];
                this.form.dtl = Array.isArray(product) ? product : [product];
                this.$set(this.form, 'bom', Array.isArray(bom) ? bom : []);
                this.showImpotDialog = false;
            } else {
                this.messageShow(res);
            }
        },
        uploadError(r) {
            this.$message.error('上传失败');
        },
        outTem() {
            this.$axios
                .get(`${this.$baseURL}template_export_barcodesout`, {
                    params: {
                        token: this.token,
                        type: '明细'
                    },
                    responseType: 'arraybuffer'
                })
                .then((response) => {
                    //创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '明细导入模板.xls';
                    link.click();
                });
        },
        // 获取页面信息-----------------------------------------
        geData(no) {
            this.$load.show();
            this.isedit = true;
            let bill_nos = this.$route.query.bill_no;
            let ids = this.$route.query.id;
            let bill_no = '';
            let id = '';
            if (bill_nos || ids) {
                this.type = null;
                bill_no = bill_nos;
                id = ids;
            }
            if (no) {
                id = no;
            }
            this.isAdd = false;
            apiBarcodesoutGetData({
                type: this.type,
                id,
                bill_no
            }).then((res) => {
                // 数据加载完成后关闭加载动画
                this.$load.close();
                if (res.code == 2000) {
                    let info = res.data;
                    this.form = info.data;
                    // 初始化物料明细数组
                    if (!this.form.bom) {
                        this.$set(this.form, 'bom', []);
                    }
                    this.last = info.last;
                    this.first = info.first;
                    this.topLeftForm = info.data.inmain;
                    this.maxHeight = 480;
                    if (this.form.check == 1) {
                        this.isCheck = true;
                    } else {
                        this.isCheck = false;
                    }
                    if (res.data.data.dtl.length > 4) {
                        let length = res.data.data.dtl.length - 4;
                        if (res.data.dtl.length > 10) {
                            length = 6;
                        }
                        let addHeight = length * 48;
                        this.maxHeight += addHeight;
                    }
                } else {
                    this.type = '4';
                    if (res.data.info == '暂无数据' || res.data.info == '没有这条数据') {
                        this.form = { dtl: [], bill: [], amt: [], bom: [] };
                        this.$forceUpdate();
                        this.nullBtn = true;
                    }
                    this.$message.error(res.data.info);
                }
            }).catch(() => {
                this.$load.close();
            });
        },

        //列配置相关接口
        getTable() {
            apiGetListCorrespondingData({
                id: '74'
            }).then((res) => {
                // this.rkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalRkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.rkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable1() {
            apiGetListCorrespondingData({
                id: '75'
            }).then((res) => {
                this.zkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalZkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.zkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable2() {
            apiGetListCorrespondingData({
                id: '76'
            }).then((res) => {
                this.fkKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalFkKeyList = res.data;
                    // 根据当前语言转换列名
                    this.fkKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        getTable3() {
            apiGetListCorrespondingData({
                id: '147'
            }).then((res) => {
                this.bmbKeyList = res.data;
                if (res.code == 2000) {
                    // 保存原始数据（包含所有语言）
                    this.originalBmbKeyList = res.data;
                    // 根据当前语言转换列名
                    this.bmbKeyList = translateColumns(res.data, this.$i18n ? this.$i18n.locale : 'zh-CN');
                }
            });
        },
        changeTable(type) {
            if (type == 1) {
                this.keyList = this.rkKeyList.map((item) => item);
                this.keyStatus = '74';
            } else if (type == 2) {
                this.keyList = this.zkKeyList.map((item) => item);
                this.keyStatus = '75';
            } else if (type == 3) {
                this.keyList = this.fkKeyList.map((item) => item);
                this.keyStatus = '76';
            } else if (type == 4) {
                this.keyList = this.bmbKeyList.map((item) => item);
                this.keyStatus = '147';
            }
            this.drawers = true;
        },

        checkMove() {
        },
        keycancel() {
            this.drawers = false;
            this.getTable();
            this.getTable1();
            this.getTable2();
            this.getTable3();
        },
        liClick(type, item, index) {
            if (type === 'del') {
                this.$set(this.keyList[index], 'column_status', '0');
            } else if (type === 'add') {
                this.$set(this.keyList[index], 'column_status', '1');
            }
        },
        keyConfirm() {
            let keyList = JSON.stringify(this.keyList);
            apiUpdateListCorrespondingData({
                column: keyList,
                id: this.keyStatus
            }).then((res) => {
                this.keycancel();
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    this.refushTable = !this.refushTable;
                } else if (res.code == 4000) {
                    this.$message.warning(res.data.info);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        // 获取下拉框信息---------------------------------------
        getStoneData() {
            apiBarcodesoutGetPull({}).then((res) => {
                if (res.code == 2000) {
                    this.allArr = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async getDivideInfo(t) {
            if (this.topIptInsjOrder.trim() == '') {
                this.$message.info('请输入入库单号后进行查询');
                return;
            }
            let isuse = await apiIsOrderQuote({ salesj_no: this.topIptInsjOrder });
            if (isuse.data.isUse == 0) {
                this.getPassTestData(t);
            } else {
                this.$confirm('此入库单号已被引用，是否继续？', '提示', {
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.getPassTestData(t);
                    })
                    .catch(() => {
                        this.topIptInsjOrder = '';
                    });
            }
            return;
        },
        getPassTestData(t) {
            apiGetDividedBtnInfo({ salesj_no: this.topIptInsjOrder }).then((res) => {
                if (res.code == 2000) {
                    this.topLeftForm = res.data.inmain;
                    if (t == 'btn') {
                        this.form.dtl = res.data.indtl;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.topIptInsjOrder = '';
            });
        },
        iptKeydownEvent(e) {
            if (e.keyCode === 13) {
                this.getDivideInfo('ipt');
            }
        },
        changeData(row, type, e) {
            // 假设我们已经有了 type 和 row 的定义
            const selectedNo = row[`${type}_no`]; // 获取当前行的编号
            const arrayToSearch = this.allArr[type]; // 获取数据源

            const idx = arrayToSearch.findIndex((item) => item[`${type}_no`] === selectedNo); // 找到索引

            const info = arrayToSearch[idx]; // 取出相应的信息
            if (e == 'dtl') {
                row.gold_style_no = info.gold_style_no;
                row.silver_style_no = info.silver_style_no;
            }
            if (!Array.isArray(arrayToSearch)) {
                console.error(`allArr[${type}] is not an array or is undefined`);
                return; // 如果 arrayToSearch 不是数组，直接返回
            }

            if (idx !== -1) {
                // 在这里，我们只更新 row[`${type}_no`] 和 row[`${type}_name`]，而不改变其他值
                row[`${type}_no`] = info[`${type}_no`]; // 更新当前行的编号
                row[`${type}_name`] = info[`${type}_name`]; // 更新当前行的名称
            } else {
                console.warn(`No entry found for selectedNo: ${selectedNo}`);
            }
        },
        exportFile() {
            getExportExcel('billexport_barcodesout', { id: this.form.id }, '条码出库');
        },
        // 撤回操作--------------------------------------
        refreshData(no) {
            this.isedit = true;
            this.isAdd = false;
            this.insertKeywords = [];
            this.dynamicTags = [];
            this.form = { dtl: [], bom: [] };
            this.geData(no);
            if (this.$route.query.isadd == 0) {
                this.$router.replace('/barcodesout');
            }
        },
        //首次进入页面 页面不可编辑状态--------------------------------
        handelEdit() {
            apiBarcodesoutIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code == 2000) {
                    this.isSave = true;
                    if (this.isedit == true) {
                        if (this.form.check == 0) {
                            this.isedit = false;
                            if (this.form.amt.length == 0) {
                                this.insertEvent2(-1);
                            }
                            // if (this.form.dtl.length == 0) {
                            //     this.insertEvent(-1);
                            // }
                            if (this.form.bill.length == 0) {
                                this.insertEvent1(-1);
                            }
                        } else if (this.form.check == 1) {
                            this.isCheck = true;
                        }
                    }
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 保存
        saveItSub() {
            const billArray = Array.isArray(this.form.bill) ? this.form.bill : [];

            // 检查是否存在结价金额为0的记录
            const hasInvalidBillItems = billArray.some(
                // item => item.bill_mode_no === 'BALPRC' && item.style_no && (!item.amt || item.amt == 0)
                item => {
                    // 查找 pullList.bill_mode 中 bill_mode_no 相同且 mode 为 0 的项
                    const billModes = this.pullList.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && mode.mode === 0
                    );
                    return matchingBillMode && item.style_no && (!item.amt || item.amt == 0);
                }
            );

            // 检查是否存在结料且金额不为0的记录
            const hasInvalidTranItems = billArray.some(
                // item => item.bill_mode_no === 'TRAN' && item.style_no && item.amt && item.amt != 0
                item => {
                    // 查找 pullList.bill_mode 中 bill_mode_no 相同且 mode 为 1 或 -1 的项
                    const billModes = this.pullList.bill_mode || [];
                    const matchingBillMode = billModes.find(
                        mode => mode.bill_mode_no === item.bill_mode_no && (mode.mode === 1 || mode.mode === -1)
                    );
                    return matchingBillMode && item.style_no && item.amt && item.amt != 0;
                }
            );

            if (hasInvalidBillItems) {
                this.$confirm('账款明细存在结价金额为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {
                });
            } else if (hasInvalidTranItems) {
                this.$confirm('账款明细存在结料且金额不为0的记录，是否继续保存？', '提示', {
                    type: 'warning'
                }).then(() => this.proceedToSave()).catch(() => {
                });
            } else {
                this.proceedToSave();
            }
        },

        proceedToSave() {
            if (Number(this.wgtTotal) != Number(this.totalWgt)) {
                this.$confirm('账款明细重量与货品明细重量不一致，是否保存？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        this.saveIt();
                    })
                    .catch(() => {
                    });
            } else {
                this.saveIt();
            }
        },
        // 保存修改------------------------------------------
        saveIt() {
            if (this.isSave) {
                this.isSave = false;
                let data = this.$deepClone(this.form);
                // console.log(this.form, '妈的喜欢乱写');
                let dtl = this.$refs.xTable1.getTableData().fullData;
                data.dtl = dtl;
                data['inmain'] = this.topLeftForm;
                data['check'] = this.form.check == true ? '1' : '0';
                data.bill = this.$refs.billTable.getTableData().fullData;
                data.amt = this.$refs.amtTable.getTableData().fullData;
                data.bom = this.$deepClone(this.form.bom || []);

                // return;
                this.$load.show();
                if (this.isAdd == true) {
                    apiBarcodesoutAddData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('添加成功'); //添加商品
                            let info = res.data;
                            this.form = info.data;
                            // 初始化物料明细数组
                            if (!this.form.bom) {
                                this.$set(this.form, 'bom', []);
                            }
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isAdd = false;
                            this.isedit = true;
                            if (this.$route.query.isadd == 0) {
                                this.$router.replace('/barcodesout');
                            }
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                } else {
                    apiBarcodesoutUpdateData({ ...data }).then((res) => {
                        if (res.code == 2000) {
                            this.$message.success('修改成功'); //修改商品
                            let info = res.data;
                            this.form = info.data;
                            // 初始化物料明细数组
                            if (!this.form.bom) {
                                this.$set(this.form, 'bom', []);
                            }
                            this.last = info.last;
                            this.first = info.first;
                            this.topLeftForm = info.data.inmain;
                            this.isedit = true;
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        } else {
                            this.$message.error(res.data.info);
                            setTimeout(() => {
                                this.isSave = true;
                            }, 3000);
                        }
                        this.$load.close();
                    });
                }
                this.insertKeywords = [];
                this.dynamicTags = [];
            }
        },
        //添加产品-----------------------------------
        add() {
            this.isSave = true;
            if (this.isAdd == false) {
                this.isedit = false;
                this.form = { bill_date: '', bom: [] };
                this.topLeftForm = {};
                this.form.check = false;
                this.isAdd = true;
                this.isCheck = false;
                this.nullBtn = false;
                this.form.bill_date = this.$getTime();
                this.maxHeight = 480;
                const keys = Object.keys(this.allArr);
                const formKeys = keys.map((key) => `${key}_no`);
                keys.forEach((key, index) => {
                    if (Array.isArray(this.allArr[key])) {
                        // 确保 this.allArr[key] 是一个数组，而不是 undefined 或 null
                        const defaultItem = this.allArr[key].find((item) => item.isdefault == 1);
                        if (defaultItem) {
                            // 确保 defaultItem 和属性 formKeys[index] 存在
                            if (defaultItem.hasOwnProperty(formKeys[index])) {
                                this.form[formKeys[index]] = defaultItem[formKeys[index]];
                            } else {
                                console.warn(`Property ${formKeys[index]} does not exist on defaultItem`);
                                this.form[formKeys[index]] = ''; // 如果属性不存在，给它赋个默认值
                            }
                        } else {
                            // 如果没有找到 defaultItem，可能需要给 this.form[formKeys[index]] 设置一个默认值
                            console.warn(`No defaultItem found for key ${key}`);
                            this.form[formKeys[index]] = '';
                        }
                    } else {
                        // 如果 this.allArr[key] 不是一个数组，输出警告
                        console.warn(`Expected an array for key ${key}, but found ${typeof this.allArr[key]}`);
                    }
                });
                setTimeout(() => {
                    for (let i = 0; i < 3; i++) {
                        // this.insertEvent(-1);
                        this.insertEvent1(-1);
                        this.insertEvent2(-1);
                    }
                }, 100);
            } else {
                this.$message.error('请先保存再添加下一个');
            }
            this.type = '4';
        },
        //删除产品-----------------------------------------
        delOrder() {
            apiBarcodesoutIsAllowUp({ id: this.form.id }).then((res) => {
                if (res.code == 2000) {
                    this.$confirm('确定要删除吗？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        apiBarcodesoutDelData({
                            id: this.form.id
                        }).then((res) => {
                            if (res.code == 2000) {
                                this.$message({ message: '删除成功', type: 'success' });
                                if (res.data.data == null) {
                                    this.form = { dtl: [], bill: [], amt: [], bom: [] };
                                    this.nullBtn = true;
                                } else {
                                    this.form = res.data.data;
                                    // 初始化物料明细数组
                                    if (!this.form.bom) {
                                        this.$set(this.form, 'bom', []);
                                    }
                                    if (this.form.check == 1) {
                                        this.isCheck = true;
                                    } else {
                                        this.isCheck = false;
                                    }
                                }
                                this.last = res.data.last;
                                this.first = res.data.first;
                            } else {
                                this.$message.error(res.data.info);
                            }
                        });
                    });
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 获取seq---------------------------
        rowChange(row) {
            row.row.seq = row.seq;
        },
        //审核按钮
        Check(val) {
            let check;
            if (this.form.check == 0) {
                check = 1;
            } else {
                check = 0;
            }
            apiBarcodesoutcheck({
                id: this.form.id,
                check: check
            }).then((res) => {
                if (res.code == 2000) {
                    this.$message.success(res.msg);
                    if (this.form.check == 0) {
                        this.isCheck = true;
                    } else {
                        this.isedit = true;
                        this.isCheck = false;
                    }
                } else {
                    this.$message.error(res.data.info);
                }
                this.type = '';
                this.geData(this.form.id);
            });
        },
        changePage(v) {
            this.type = v;
            let bill_nos = this.$route.query.bill_no;
            if (bill_nos) {
                this.$router.replace({ path: '/barcodesout' });
                this.geData(this.form.id);
                return;
            }
            this.geData(this.form.id);
        },
        //插入新数据--------------------------------------------
        async insertEvent(row) {
            let record = {
                style_no: '',
                alloy: 1,
                qty: 1,
                containloss_rate: 1,
                counter_no: ''
            };
            let { row: newRow } = await this.$refs.xTable1.insertAt(record, row);
            await this.$refs.xTable1.setActiveCell(newRow, 'seq');
            // this.$refs.stylefocus.focus();
        },
        //tbale增加条数
        async insertEvent1(row) {
            let record = {
                discount: 1,
                alloy: 1
            };
            let { row: newRow } = await this.$refs.billTable.insertAt(record, row);
            await this.$refs.billTable.setActiveCell(newRow, 'seq');
        },
        async insertEvent2(row) {
            let record = {
                currency_no: this.systemSet.currency_no
            };
            let { row: newRow } = await this.$refs.amtTable.insertAt(record, row);
            await this.$refs.amtTable.setActiveCell(newRow, 'seq');
        },
        // 新增账款明细
        addbill() {
            this.insertEvent1(-1);
        },
        delbill(scoped) {
            let length = this.$refs.billTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.billTable.remove(scoped.row);
        },
        // 新增付款明细
        addamt() {
            this.insertEvent2(-1);
        },
        delamt(scoped) {
            let length = this.$refs.amtTable.getTableData().fullData.length;
            if (length == 1) {
                this.$message.warning('至少保留一条列表数据');
                return;
            }
            this.$refs.amtTable.remove(scoped.row);
        },
        // 不可编辑-------------------------------------
        activeRowMethod() {
            if (this.isedit == false) {
                return true;
            } else {
                this.$message.error('该状态下不可编辑');
                return false;
            }
        },
        calculationBillDtl(row) {
            let trans_wgt = this.$utils.multiply(row.wgt, (row.alloy || 1));
            row.trans_wgt = Number(trans_wgt).toFixed(this.systemSet.wgt);

            let amt = (Number(row.wgt_prc) * Number(row.trans_wgt) + Number(row.qty) * Number(row.qty_prc)) * Number(row.discount);
            row.amt = Number(amt).toFixed(this.systemSet.amt);


            let original_amt = Number(row.wgt_prc) * Number(row.wgt) + Number(row.qty) * Number(row.qty_prc);
            row.original_amt = Number(original_amt).toFixed(this.systemSet.amt);
        },
        /** 计算物料明细数据*/
        calculationBom(row) {

            let amt = multiplication(Number(row.qty || 0), Number(row.qty_prc || 0))
                + multiplication(Number(row.qty || 0), Number(row.qty_prc1 || 0))
                + multiplication(Number(row.qty || 0), Number(row.qty_prc2 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.wgt_prc || 0))
                + multiplication(Number(row.wgt || 0), Number(row.wgt_prc1 || 0))
                + multiplication(Number(row.wgt || 0), Number(row.wgt_prc2 || 0))
                + Number(row.saleadd_amt || 0);
            row.amt = amt.toFixed(this.systemSet.amt);
        },
        calculationDtlDtl(row) {
            // 含耗重
            let containloss_wgt = multiplication(row.wgt, row.containloss_rate);
            row.containloss_wgt = containloss_wgt.toFixed(this.systemSet.wgt);
            // 折足重
            let trans_wgt = multiplication(row.containloss_wgt, row.alloy);
            row.trans_wgt = trans_wgt.toFixed(this.systemSet.wgt);

            let stone1_qty_amt =
                multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_qty, row.stone1_qty_wage);
            row.stone1_qty_amt = stone1_qty_amt.toFixed(this.systemSet.amt);

            let stone1_wgt_amt =
                multiplication2(row.stone1_wgt, row.stone1_wgt_prc, row.stone1_wgt, row.stone1_wgt_wage);
            row.stone1_wgt_amt = stone1_wgt_amt.toFixed(this.systemSet.amt);

            let stone2_qty_amt =
                multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_qty, row.stone2_qty_wage);
            row.stone2_qty_amt = stone2_qty_amt.toFixed(this.systemSet.amt);

            let stone2_wgt_amt =
                multiplication2(row.stone2_wgt, row.stone2_wgt_prc, row.stone2_wgt, row.stone2_wgt_wage);
            row.stone2_wgt_amt = stone2_wgt_amt.toFixed(this.systemSet.amt);

            let stone3_qty_amt =
                multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_qty, row.stone3_qty_wage);
            row.stone3_qty_amt = stone3_qty_amt.toFixed(this.systemSet.amt);

            let stone3_wgt_amt =
                multiplication2(row.stone3_wgt, row.stone3_wgt_prc, row.stone3_wgt, row.stone3_wgt_wage);
            row.stone3_wgt_amt = stone3_wgt_amt.toFixed(this.systemSet.amt);

            let stone4_qty_amt =
                multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_qty, row.stone4_qty_wage);
            row.stone4_qty_amt = stone4_qty_amt.toFixed(this.systemSet.amt);

            let stone4_wgt_amt =
                multiplication2(row.stone4_wgt, row.stone4_wgt_prc, row.stone4_wgt, row.stone4_wgt_wage);
            row.stone4_wgt_amt = stone4_wgt_amt.toFixed(this.systemSet.amt);

            let stone5_qty_amt =
                multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_qty, row.stone5_qty_wage);
            row.stone5_qty_amt = stone5_qty_amt.toFixed(this.systemSet.amt);

            let stone5_wgt_amt =
                multiplication2(row.stone5_wgt, row.stone5_wgt_prc, row.stone5_wgt, row.stone5_wgt_wage);
            row.stone5_wgt_amt = stone5_wgt_amt.toFixed(this.systemSet.amt);

            let mainstone_qty_amt =
                multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_qty, row.mainstone_qty_wage);
            row.mainstone_qty_amt = mainstone_qty_amt.toFixed(this.systemSet.amt);

            let mainstone_wgt_amt =
                multiplication2(row.mainstone_wgt, row.mainstone_wgt_prc, row.mainstone_wgt, row.mainstone_wgt_wage);
            row.mainstone_wgt_amt = mainstone_wgt_amt.toFixed(this.systemSet.amt);

            let stone_qty_amt =
                mainstone_qty_amt + stone1_qty_amt + stone2_qty_amt + stone3_qty_amt + stone4_qty_amt + stone5_qty_amt;
            row.stone_qty_amt = stone_qty_amt.toFixed(this.systemSet.amt);

            let stone_wgt_amt =
                mainstone_wgt_amt + stone1_wgt_amt + stone2_wgt_amt + stone3_wgt_amt + stone4_wgt_amt + stone5_wgt_amt;
            row.stone_wgt_amt = stone_wgt_amt.toFixed(this.systemSet.amt);

            let stone1_amt =
                multiplication2(row.stone1_qty, row.stone1_qty_prc, row.stone1_qty, row.stone1_qty_wage) +
                multiplication2(row.stone1_wgt, row.stone1_wgt_prc, row.stone1_wgt, row.stone1_wgt_wage);
            row.stone1_amt = stone1_amt.toFixed(this.systemSet.amt);

            let stone2_amt =
                multiplication2(row.stone2_qty, row.stone2_qty_prc, row.stone2_qty, row.stone2_qty_wage) +
                multiplication2(row.stone2_wgt, row.stone2_wgt_prc, row.stone2_wgt, row.stone2_wgt_wage);
            row.stone2_amt = stone2_amt.toFixed(this.systemSet.amt);

            let stone3_amt =
                multiplication2(row.stone3_qty, row.stone3_qty_prc, row.stone3_qty, row.stone3_qty_wage) +
                multiplication2(row.stone3_wgt, row.stone3_wgt_prc, row.stone3_wgt, row.stone3_wgt_wage);
            row.stone3_amt = stone3_amt.toFixed(this.systemSet.amt);

            let stone4_amt =
                multiplication2(row.stone4_qty, row.stone4_qty_prc, row.stone4_qty, row.stone4_qty_wage) +
                multiplication2(row.stone4_wgt, row.stone4_wgt_prc, row.stone4_wgt, row.stone4_wgt_wage);
            row.stone4_amt = stone4_amt.toFixed(this.systemSet.amt);

            let stone5_amt =
                multiplication2(row.stone5_qty, row.stone5_qty_prc, row.stone5_qty, row.stone5_qty_wage) +
                multiplication2(row.stone5_wgt, row.stone5_wgt_prc, row.stone5_wgt, row.stone5_wgt_wage);
            row.stone5_amt = stone5_amt.toFixed(this.systemSet.amt);

            let mainstone_amt =
                multiplication2(row.mainstone_qty, row.mainstone_qty_prc, row.mainstone_qty, row.mainstone_qty_wage) +
                multiplication2(row.mainstone_wgt, row.mainstone_wgt_prc, row.mainstone_wgt, row.mainstone_wgt_wage);
            row.mainstone_amt = mainstone_amt.toFixed(this.systemSet.amt);

            let stone_amt =
                Number(row.mainstone_amt || 0) +
                Number(row.stone1_amt || 0) +
                Number(row.stone2_amt || 0) +
                Number(row.stone3_amt || 0) +
                Number(row.stone4_amt || 0) +
                Number(row.stone5_amt || 0);
            row.stone_amt = stone_amt.toFixed(this.systemSet.amt);

            let discounted_add_qtywage = multiplication(row.add_qtywage, Number(row.add_qtywage_discount || 1));
            row.discounted_add_qtywage = discounted_add_qtywage.toFixed(this.systemSet.amt);

            let amt_wage =
                (Number(row.qty || 0) * Number(row.qty_prc || 0) +
                    Number(row.qty || 0) * Number(row.discounted_add_qtywage || 0) +
                    Number(row.wgt || 0) * Number(row.wgt_prc || 0) +
                    Number(row.wgt || 0) * Number(row.add_wgtwage || 0) +
                    Number(row.wgt || 0) * Number(row.pre_wgt_prc || 0) +
                    Number(row.containloss_wgt || 0) * Number(row.containloss_wgt_prc || 0) +
                    Number(row.add_wage || 0) -
                    Number(row.discount_amt_wage || 0))
                * Number(row.discount_wage || 1);
            row.amt_wage = amt_wage.toFixed(this.systemSet.amt);

            let metal_amt = multiplication(row.trans_wgt, row.metal_wgt_prc);
            row.metal_amt = metal_amt.toFixed(this.systemSet.amt);

            let amt = (Number(row.metal_amt || 0)
                    + Number(row.amt_wage || 0)
                    + Number(row.certificate_amt || 0)
                    + Number(row.stone_amt || 0)
                    - Number(row.discount_amt || 0))
                * Number(row.discount || 1);
            row.amt = amt.toFixed(this.systemSet.amt);
        },
        sumNum(list, field) {
            let count = 0;
            list.forEach((item) => {
                count += Number(item[field]);
            });
            return count;
        },
        // 表尾合计---------------------------------
        footerMethodDtl({ columns, data }) {
            const sumConfig = {
                amt: ['certificate_amt', 'metal_amt',
                    'qty_prc', 'add_qtywage', 'discounted_add_qtywage', 'add_wage', 'amt_wage', 'discount_amt',
                    'stone_amt', 'mainstone_amt', 'stone1_amt', 'stone2_amt', 'stone3_amt', 'stone4_amt', 'stone5_amt'
                ],
                qty: ['mainstone_qty', 'stone1_qty', 'stone2_qty', 'stone3_qty', 'stone4_qty', 'stone5_qty'],
                wgt: ['trans_wgt', 'goods_wgt', 'containloss_wgt',
                    'mainstone_wgt', 'stone1_wgt', 'stone2_wgt', 'stone3_wgt', 'stone4_wgt', 'stone5_wgt', 'trans_wgt']
            };
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    }
                    if (column.property == 'qty') {
                        let totalQty = this.$utils.sum(data, column.property).toFixed(this.systemSet.qty);
                        this.$set(this.form, 'sumqty', totalQty);
                        return `${totalQty} `;
                    }
                    if (column.property == 'wgt') {
                        this.$forceUpdate();
                        let totalWgt = this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt);
                        this.wgtTotal = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        // this.form.sumwgt = `${totalWgt ? totalWgt : 0} `;
                        this.$set(this.form, 'sumwgt', totalWgt);
                        return `${totalWgt} `;
                    }
                    if (column.property == 'amt') {
                        this.dtlAmtTotal = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        const calculatedAmt = (Number(this.dtlAmtTotal) + Number(this.billAmtTotal) + Number(this.bomAmtTotal));
                        this.form.sumamt = this.$formatOrderAmt(calculatedAmt, this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = calculatedAmt.toFixed(this.systemSet.amt);
                        this.$forceUpdate();
                        return this.dtlAmtTotal;
                    }
                    for (const [type, properties] of Object.entries(sumConfig)) {
                        if (properties.includes(column.property)) {
                            return `${this.$utils.sum(data, column.property).toFixed(this.systemSet[type])} `;
                        }
                    }
                    return '-';
                })
            ];
        },
        footerMethodBill({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'wgt') {
                        this.totalWgt = `${this.$utils.sum(data, column.property).toFixed(this.systemSet.wgt)}`;
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else if (column.property == 'qty') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'original_amt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else if (column.property == 'amt') {
                        this.billAmtTotal = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        const calculatedAmt = (Number(this.dtlAmtTotal) + Number(this.billAmtTotal) + Number(this.bomAmtTotal));
                        this.form.sumamt = this.$formatOrderAmt(calculatedAmt, this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = calculatedAmt.toFixed(this.systemSet.amt);
                        this.$forceUpdate();
                        return this.billAmtTotal;
                    } else if (column.property == 'trans_wgt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        footerMethodAmt({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        this.form.settle_amt = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        this.$forceUpdate();
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        footerMethodBom({ columns, data }) {
            return [
                columns.map((column, columnIndex) => {
                    if (columnIndex === 0) {
                        return '合计';
                    } else if (column.property == 'amt') {
                        this.bomAmtTotal = `${this.sumNum(data, column.property).toFixed(this.systemSet.amt)}`;
                        const calculatedAmt = (Number(this.dtlAmtTotal) + Number(this.billAmtTotal) + Number(this.bomAmtTotal));
                        this.form.sumamt = this.$formatOrderAmt(calculatedAmt, this.systemSet.zero_deal, this.systemSet.amt);
                        this.form.sumamt2 = calculatedAmt.toFixed(this.systemSet.amt);
                        this.$forceUpdate();

                        return this.bomAmtTotal;
                    } else if (column.property == 'qty') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.qty)}`;
                    } else if (column.property == 'wgt') {
                        return `${this.sumNum(data, column.property).toFixed(this.systemSet.wgt)}`;
                    } else {
                        return '-';
                    }
                })
            ];
        },
        editClosedEvent() {
            this.foottotal();
        },
        foottotal() {
            let dtl = this.$refs.xTable1.getTableData().fullData;
            let bill = this.$refs.billTable.getTableData().fullData;
            let amt = this.$refs.amtTable.getTableData().fullData;
            insjQuitSum({ dtl, bill, amt }).then((res) => {
                this.form.sumqty = res.data.sumqty;
                this.form.sumwgt = res.data.sumwgt;
                this.form.sumtrans_wgt = res.data.sumtrans_wgt;
                this.form.settle_amt = res.data.settle_amt;
                this.form.tran_qty = res.data.tran_qty;
                this.form.tran_wgt = res.data.tran_wgt;
                this.form.balprc_qty = res.data.balprc_qty;
                this.form.balqty_wgt = res.data.balprc_wgt;
                this.form.sumamt = res.data.sumamt;
                this.form.sumamt2 = res.data.sumamt2;
                this.$forceUpdate();
            });
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '165'
            }).then((res) => {
                if (res.code == 2000) {
                    //
                    this.perData = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        // refreshs() {
        //     this.$forceUpdate();
        // },
        //获取系统设置信息
        getSystem() {
            apiSystem({}).then((res) => {
                if (res.code == 2000) {
                    this.systemSet = res.data;
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        // 列表出现新增
        dtlenter(row) {
            if (!this.isedit) {
                this.dtlIndex = row.$rowIndex;
            }
        },
        dtlleave() {
            this.dtlIndex = '-1';
        },
        // 新增分称管理
        adddtl() {
            this.insertEvent(-1);
            let length = this.$refs.xTable1.getTableData().fullData.length;
            if (length > 4 && length < 11) {
                this.maxHeight += 48;
            }
        },
        deldtl(scoped) {
            // let length = this.$refs.xTable1.getTableData().fullData.length;
            // if (length == 1) {
            //     this.$message.warning('至少保留一条列表数据');
            //     return;
            // }
            let row = scoped.row;
            this.$refs.xTable1.remove(row);
            // 根据条码删除物料明细中相同条码的数据
            if (row && row.barcode && this.form.bom && this.form.bom.length) {
                let filterBom = this.form.bom.filter((item) => item.barcode != row.barcode);
                this.$set(this.form, 'bom', filterBom);
            }
        },
        goHistory() {
            this.$router.push({ path: '/barcodesoutStorageHistory', query: { page: 'barcodesout' } });
        },
        handleInput(row, field, type, tableRef) {
            if (tableRef == 'dtlTable') {
                this.calculationDtlDtl(row);
            }
            if (tableRef == 'billTable') {
                this.calculationBillDtl(row);
            }
            if (tableRef == 'bomTable') {
                this.calculationBom(row);
            }
            if (type === 'number') {
                // 只允许数字、一个小数点和一个负号
                let inputValue = row[field]
                    .replace(/[^0-9.-]/g, '') // 删除非数字、非小数点和非负号的字符
                    .replace(/(\..*)\./g, '$1'); // 只保留第一个小数点

                // 如果输入值只有一个小数点，则替换为 '0.'
                if (inputValue === '.') {
                    inputValue = '0.';
                }
                // 处理负号，确保负号只能出现在字符串的开头
                if (inputValue && inputValue[0] === '-') {
                    // 负号在开头，允许它存在
                    inputValue = '-' + inputValue.slice(1).replace(/[^0-9.]/g, ''); // 清除负号后面的非法字符
                } else {
                    // 如果没有负号或者负号不是在开头，去掉所有负号
                    inputValue = inputValue.replace(/-/g, '');
                }

                // 更新 row[field] 的值
                row[field] = inputValue;
            }
        },
        // 尝试开发table()
        jumptable(e, row, type) {
            //所有列数据
            let column = this.$refs.xTable1.getTableColumn().fullColumn;
            // 所有行数据
            var rows = this.$refs.xTable1.getTableData().fullData;
            // 根据当前行获取行下标
            var rowIndex = this.$refs.xTable1.getVTRowIndex(row);

            // 当前列
            let nowcolumn = this.$refs.xTable1.getColumnByField(type);
            // 根据当前列获取下标
            let columnIndex = this.$refs.xTable1.getColumnIndex(nowcolumn);
            // 列数据总长度
            var length = column.length;

            // 右移：查找下一个可编辑的列
            var jumpnum = columnIndex + 1;
            while (jumpnum < length) {
                if (!column[jumpnum]) break;
                // 从 rkKeyList 中查找对应列的 column_disabled 属性
                let targetField = column[jumpnum].property || column[jumpnum].field;
                let targetColumnConfig = this.rkKeyList.find(item => item.field === targetField);
                // 如果找不到配置或 column_disabled != 1，则是可编辑的
                if (targetColumnConfig && targetColumnConfig.column_disabled == 1) {
                    jumpnum++;
                } else {
                    break;
                }
            }

            // 左移：查找上一个可编辑的列
            var jumpnumleft = columnIndex - 1;
            while (jumpnumleft >= 0) {
                if (!column[jumpnumleft]) break;
                // 从 rkKeyList 中查找对应列的 column_disabled 属性
                let targetField = column[jumpnumleft].property || column[jumpnumleft].field;
                let targetColumnConfig = this.rkKeyList.find(item => item.field === targetField);
                // 如果找不到配置或 column_disabled != 1，则是可编辑的
                if (targetColumnConfig && targetColumnConfig.column_disabled == 1) {
                    jumpnumleft--;
                } else {
                    break;
                }
            }

            // 获取目标列的property
            var downtype = column[jumpnum] && jumpnum < length ? column[jumpnum].property : undefined;
            var uptype = column[jumpnumleft] && jumpnumleft >= 0 ? column[jumpnumleft].property : undefined;
            if (e.keyCode == '39' || e.keyCode == '13' || e.keyCode == '9') {
                if (jumpnum == length) {
                    //最后一列换行
                    if (rowIndex + 1 == rows.length) {
                        // 最后一行 先增加行在换行
                        this.adddtl();
                        rows = this.$refs.xTable1.getTableData().fullData;
                        // 换行
                        setTimeout(() => {
                            this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                        }, 100);
                    } else {
                        this.$refs.xTable1.setActiveRow(rows[rowIndex + 1]);
                    }
                } else {
                    let allowBreak = true;
                    rows.forEach((item, index) => {
                        if (index === rowIndex) {
                            return;
                        }
                        if (item.barcode && item.barcode === row.barcode) {
                            this.$message.error('条码号不能重复');
                            row.barcode = '';
                            allowBreak = false;
                        }
                    });
                    if (allowBreak) {
                        // 跳转到下一列
                        this.$refs.xTable1.setActiveCell(row, downtype);
                    }
                }
            }
            if (e.keyCode == '37') {
                if (jumpnumleft == 0) {
                    //向上换行换行
                    this.$refs.xTable1.setActiveRow(rows[rowIndex - 1]);
                } else {
                    // 跳转到上一列
                    this.$refs.xTable1.setActiveCell(row, uptype);
                }
            }

            // 向下移动 (keyCode == 40)
            if (e.keyCode == '40') {
                e.preventDefault(); // 阻止默认行为
                // 确保下移时在当前列，跳到下一行的相同列
                if (rowIndex + 1 < rows.length) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex + 1], nowcolumn.property);
                }
            }

            // 向上移动 (keyCode == 38)
            if (e.keyCode == '38') {
                e.preventDefault(); // 阻止默认行为
                // 确保上移时在当前列，跳到上一行的相同列
                if (rowIndex - 1 >= 0) {
                    this.$refs.xTable1.setActiveCell(rows[rowIndex - 1], nowcolumn.property);
                }
            }
        }
    }
};
</script>

<style scoped lang="scss">
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}

.table1 {
    padding: 15px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 10px;
    padding-top: 0;

    .title {
        height: 44px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        p {
            font-size: 16px;
            color: #000;
        }
    }

    .ipt {
        display: flex;
        align-items: center;
        width: 20%;

        p {
            font-size: 16px;
            color: #000;
            width: 30%;
        }
    }
}

.table_warpper {
    display: flex;

    .table2 {
        width: 60%;
        margin-right: 15px;
    }

    .table3 {
        width: 40%;
    }
}

/* 明细表格与物料明细表格：明细占三分之二，物料明细占三分之一 */
.dtl_bom_warpper {
    display: flex;

    .dtl_main {
        width: 66.66%;
        margin-right: 15px;
    }

    .dtl_main_full {
        width: 100%;
        margin-right: 0;
    }

    .bom_dtl {
        width: 33.33%;
    }
}
</style>
<style>
/* .el-dialog__wrapper {
    left: 30%;
} */
.vxe-table .vxe-body--row.row--stripe {
    background-color: #ecf5ff;
}

.vxe-table thead {
    background-color: #ecf5ff;
}

.vxe-table {
    background: #fff;
}

.vxe-table .vxe-body--row.row--hover,
.vxe-table .vxe-body--row.row--hover.row--stripe {
    background-color: #ecf5ff;
}

.box1 .el-select {
    width: 20%;
}

.gray {
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
}

.el-select {
    width: 100%;
}

.list-item1:hover {
    background-color: #f5f7fa;
}

.orderorder {
    padding-bottom: 65px;
    box-sizing: border-box;
}

.orderorder .vxe-table .vxe-body--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-footer--column:not(.col--ellipsis),
.orderorder .vxe-table .vxe-header--column:not(.col--ellipsis) {
    padding: 12px 0;
}

.orderorder .vxe-table--footer-wrapper.body--wrapper {
    color: red;
}
</style>
<style scoped lang="scss">
.batchBtn {
    margin-left: 5px;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid #409eff !important;
}

.footer {
    height: 88px;
    background-color: #fff;
    z-index: 999;
    padding: 10px;
    box-sizing: border-box;
    position: absolute;
    bottom: 0;
    left: 10px;
    width: 98%;
    box-shadow: 0px -2px 6px 0px #e2eeff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 40px;
    box-sizing: border-box;

    div {
        display: flex;

        p {
            width: 20%; /* 调整为百分比 */
            min-width: 80px; /* 保证在极小的屏幕上也不会过小 */
        }

        .buttom {
            height: 32px;
            line-height: 0;
        }

        .el-form-item {
            margin-right: 15px;
            margin-bottom: 5px;
        }
    }
}

.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .centerItem {
        width: 48%;
        text-align: center;

        /deep/ .el-upload--text {
            width: 100%;
            height: 100%;
        }

        /deep/ .el-upload-dragger {
            width: 100%;
        }
    }

    .leftItem {
        width: 48%;
        height: 180px;
        cursor: pointer;
        box-sizing: border-box;
        position: relative;
        border-radius: 8px;
        border: 1px dashed #97a8be;

        .itemText {
            position: absolute;
            top: 70%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    // width: 178px;
    // height: 178px;
    line-height: 178px;
    text-align: center;
}

.el-tag {
    margin-right: 10px;
    margin-bottom: 10px;
}

.button-new-tag {
    margin-left: 10px;
}
</style>

<style lang="scss">
.batch-field-dialog {
    .el-dialog__header {
        border-bottom: 1px solid #e8eaec;
        padding-bottom: 15px;
    }

    .el-dialog__body {
        padding: 20px 24px;
    }

    .batch-field-content {
        .batch-field-section {
            margin-bottom: 20px;

            &:last-child {
                margin-bottom: 0;
            }
        }

        .batch-field-label {
            display: flex;
            align-items: center;
            margin-bottom: 12px;
            font-size: 14px;
            font-weight: 600;
            color: #303133;

            i {
                margin-right: 6px;
                color: #409eff;
                font-size: 16px;
            }

            .select-all-checkbox {
                margin-left: auto;
                font-weight: normal;
                font-size: 13px;
                color: #409eff;
            }
        }

        .checkbox-row {
            background: #f8f9fa;
            border-radius: 6px;
            padding: 8px 12px;
            max-height: 220px;
            overflow-y: auto;

            .el-checkbox-group {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 4px 0;
            }

            .checkbox-item {
                display: flex;
                align-items: center;

                .el-checkbox {
                    margin-right: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }

    .dialog-footer {
        .el-button {
            min-width: 80px;
        }
    }
}
</style>
